import { Empty, Radio, Switch } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Button,
    Card,
    Col,
    Form,
    message,
    Modal,
    Row,
    Statistic,
    Table,
    Tag,
    Tooltip,
    Typography,
    Upload,
    UploadProps,
    Space,
    Spin,
    Dropdown,
    Avatar,
    Select,
    Input,
    Popconfirm,
    Progress,
    List,
    DatePicker,
    Timeline,
    Tabs
} from "antd";
import { ColumnsType } from "antd/es/table";
import { BiRefresh, BiRevision } from "react-icons/bi";
import { FaCheck, FaCode, FaTimes } from "react-icons/fa";
import JutgeColors from "../../../../styles/JutgeColors";
import { GetPractica } from "../../../../dao/jutge/GetPracticaId";
import { InboxOutlined } from "@mui/icons-material";
import { RcFile } from "antd/es/upload";
import { MdOutlineTextDecrease } from "react-icons/md";
import { PostJutgePracticaIdUsuariIdPenality } from "../../../../dao/jutge/PostJutgePracticaIdUsuariIdPenality";
import { SuspendrePerIA } from "../../../../dao/jutge/SuspendrePerIA";
import { GetRankingsUsuariId } from "../../../../dao/jutge/GetRankingsUsuariId";
import CodiFontModal from "./CodiFontModal";
import { PostJutgePracticaIdUsuariIdMulti } from "../../../../dao/jutge/PostJutgePracticaIdUsuariIdMulti";
import PracticaIdTests from "./PracticaIdTests";
import PenaltyModal from "./components/PenaltyModal";
import { DeleteJutgePracticaFile } from "../../../../dao/jutge/DeleteJutgePracticaFile";
import { PostJutgePracticaIdUsuariIdReevaluar } from "../../../../dao/jutge/PostJutgePracticaIdUsuariIdReevaluar";
import {
    DownloadOutlined,
    FolderOpenOutlined,
    DeleteOutlined,
    ReloadOutlined,
    UploadOutlined,
    RotateRightOutlined,
    DesktopOutlined,
    LoadingOutlined,
    ExportOutlined,
    PlayCircleOutlined,
    StopOutlined,
    MoreOutlined,
    SearchOutlined,
    UserSwitchOutlined,
    GiftOutlined,
    HistoryOutlined,
    LockOutlined,
    ThunderboltOutlined,
    LeftOutlined,
    RightOutlined,
    FileOutlined,
    MinusCircleTwoTone,
    CodeOutlined,
    CopyOutlined,
    ClockCircleOutlined,
    WarningOutlined,
    EyeInvisibleOutlined,
    UndoOutlined
} from '@ant-design/icons';
import { GetUsuarisRecompensesProblema } from "../../../../dao/jutge/GetUsuarisRecompensesProblema";
import { GetAlumneId } from "../../../../dao/GetAlumneId";
import { DefaultAulumneInfo } from "../../../../model/AlumneInfo";
import dayjs, { Dayjs } from 'dayjs';
import Editor, { DiffEditor } from '@monaco-editor/react';
import UseWebSocketSubscription from "../../../UseWebSocketSubscription";
import IdeFileBrowserModal from "../../ide/IdeFileBrowserModal";

const { Dragger } = Upload;
const { Title, Text } = Typography;

interface RecordType {
    id_usuari: string;
    alumne: string;
    avatar?: string;
    correctes: number;
    incorrectes: number;
    nota: number;
    enviaments?: any[];
    hasTests?: boolean;
    codi?: string;
    files?: { name: string, content: string }[];
    output?: string;
    json?: any;
    idAula: string;
    nomaula: string;
    origen?: number;
    tipus?: string | number;
    isSuspendedByIa?: boolean;
}

interface UploadCellProps {
    record: RecordType;
    id_practica: string;
}

const UploadCell: React.FC<UploadCellProps> = ({ record, id_practica }) => {
    const [enviado, setEnviado] = useState(false);
    const [selectedUids, setSelectedUids] = useState<string[]>([]);
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);

    const props: UploadProps = {
        name: 'file',
        multiple: true,
        fileList: uploadedFiles,
        beforeUpload: (file) => {
            const path = (file as any).webkitRelativePath || file.name;
            const lowerPath = path.toLowerCase();

            if (
                lowerPath.includes(".metadata") ||
                lowerPath.includes(".ds_store") ||
                lowerPath.includes("thumbs.db") ||
                (!lowerPath.endsWith(".java") && !lowerPath.endsWith(".jsp")) ||
                lowerPath.endsWith("module-info.java") ||
                lowerPath.includes("test")
            ) {
                return Upload.LIST_IGNORE;
            }
            return true;
        },
        onChange(info) {
            setUploadedFiles(info.fileList);
            if (info.file.status === 'done') message.success(`${info.file.name} pujat correctament.`);
            else if (info.file.status === 'error') message.error(`${info.file.name} pujada fallida.`);
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            const rcFile = file as RcFile;
            const uid = rcFile.uid;
            const formData = new FormData();
            formData.append('file', rcFile);
            formData.append('uid', uid);

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}:8061/jutge/practica/${id_practica}/usuaris/${record.id_usuari}/upload`,
                    { method: 'POST', body: formData }
                );

                if (response.ok) {
                    if (onSuccess) onSuccess("ok");
                    setSelectedUids(prev => [...prev, uid]);
                } else {
                    if (onError) onError(new Error("Upload failed"));
                }
            } catch (error) {
                console.error('Error:', error);
                if (onError) onError(new Error("Network error"));
                message.error("Error al pujar el fitxer.");
            }
        },
        onRemove: async (file) => {
            const uid = (file as any).uid;
            try {
                await DeleteJutgePracticaFile(id_practica, record.id_usuari, uid);
                setSelectedUids(prev => prev.filter(u => u !== uid));
                setUploadedFiles(prev => prev.filter(f => f.uid !== uid));
                message.success("Fitxer eliminat correctament");
                return true;
            } catch (e) {
                message.error("Error al eliminar el fitxer");
                return false;
            }
        }
    };

    const submitData = async () => {
        if (selectedUids.length === 0) {
            message.warning("Has de pujar almenys un fitxer abans d'enviar!");
            return;
        }
        setEnviado(true);
        try {
            const studentOrigenStr = record.origen === 1 ? 'WEB_DESAFIO' : (record.origen === 2 ? 'UNITY' : 'WEB_NORMAL');
            const response = await PostJutgePracticaIdUsuariIdMulti(id_practica + "", record.id_usuari, selectedUids, studentOrigenStr);
            if (response?.response && response.response.startsWith("Tests ejecutados")) {
                message.success("TEST OK");
                setUploadedFiles([]);
                setSelectedUids([]);
            } else {
                message.error(response?.response || "Error message missing");
            }
        } catch (e) {
            console.error(e);
            message.error("Error durant l'enviament");
        }
        setEnviado(false);
    };

    return (
        <Form onFinish={submitData} layout="vertical" style={{ minWidth: 250 }}>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <Upload {...props} showUploadList={false}>
                    <Button icon={<UploadOutlined />} size="small" type="dashed">Fitxers</Button>
                </Upload>
                <Upload {...props} directory={true} showUploadList={false}>
                    <Button icon={<FolderOpenOutlined />} size="small" type="dashed">Carpeta</Button>
                </Upload>
            </div>

            {/* Custom file list to show remove icons explicitly */}
            {uploadedFiles.length > 0 && (
                <div style={{ maxHeight: 150, overflowY: 'auto', marginBottom: 8, fontSize: 12 }}>
                    {uploadedFiles.map(f => (
                        <div key={f.uid} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f5f5f5', padding: '2px 4px', marginBottom: 2 }}>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                            <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => props.onRemove && props.onRemove(f)} />
                        </div>
                    ))}
                </div>
            )}

            <Form.Item style={{ margin: 0 }}>
                <Button
                    htmlType="submit"
                    loading={enviado}
                    disabled={selectedUids.length === 0 || enviado}
                    type="primary"
                    size="small"
                    block
                >
                    Enviar ({selectedUids.length})
                </Button>
            </Form.Item>
        </Form>
    );
};

interface PracticaIdAlumnesProps {
    id_practica?: string | number;
    onClose?: () => void;
}

const PracticaIdAlumnes: React.FC<PracticaIdAlumnesProps> = (props) => {
    const { isLoggedIn, userId, setLoggedIn, setUserId, setUser, setAlumneInfo, setUserPermisos } = useContext(AuthContext);
    const params = useParams();
    const effectivePracticaId = props.id_practica ? String(props.id_practica) : params.id_practica;
    const id_practica = effectivePracticaId;
    const [dades, setDades] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [practica, setPractica] = useState<any>(null);

    // Modals state
    const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);
    const [isOutputModalOpen, setIsOutputModalOpen] = useState(false);
    const [selectedCode, setSelectedCode] = useState("");
    const [selectedOutput, setSelectedOutput] = useState<any>("");
    const [isPenaltyModalOpen, setIsPenaltyModalOpen] = useState(false);
    const [selectedUserForPenalty, setSelectedUserForPenalty] = useState<RecordType | null>(null);
    const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
    const [selectedUserForTests, setSelectedUserForTests] = useState<RecordType | null>(null);

    const [initialMode, setInitialMode] = useState<'subtract' | 'add'>('subtract');

    // Live Eval Modal
    const [isBulkEvalModalOpen, setIsBulkEvalModalOpen] = useState(false);
    const [evalLogs, setEvalLogs] = useState<{ name: string, status: 'loading' | 'success' | 'warning' | 'error', msg?: string }[]>([]);
    const [evalProgress, setEvalProgress] = useState(0);
    const [evalInProgress, setEvalInProgress] = useState<string | null>(null);

    // IDE Action Modal (Specific for a Student)
    const [isIdeModalOpen, setIsIdeModalOpen] = useState(false);
    const [selectedUserForIde, setSelectedUserForIde] = useState<RecordType | null>(null);
    const [ideUrl, setIdeUrl] = useState("");
    const [ideLoading, setIdeLoading] = useState(false);
    const [uploadModalStudent, setUploadModalStudent] = useState<RecordType | null>(null);

    const [rewardsData, setRewardsData] = useState<any[]>([]);
    const [selectedStudentRewards, setSelectedStudentRewards] = useState<any | null>(null);
    const [rewardsModalVisible, setRewardsModalVisible] = useState(false);

    // Telemetry and IDE Lock states
    const [telemetrySessions, setTelemetrySessions] = useState<Record<string, any>>({});
    const [telemetryModalVisible, setTelemetryModalVisible] = useState(false);
    const [telemetryStudent, setTelemetryStudent] = useState<any | null>(null);
    const [telemetryEvents, setTelemetryEvents] = useState<any[]>([]);
    const [telemetryClipboardEvents, setTelemetryClipboardEvents] = useState<any[]>([]);
    const [telemetryLockEvents, setTelemetryLockEvents] = useState<any[]>([]);
    const [activeTelemetryTabKey, setActiveTelemetryTabKey] = useState<'timeline' | 'clipboard' | 'locks'>('timeline');
    const [telemetryLoading, setTelemetryLoading] = useState(false);
    const [telemetryDate, setTelemetryDate] = useState<Dayjs>(dayjs());
    const [selectedFileFilter, setSelectedFileFilter] = useState<string | null>(null);
    const [clipboardActionFilter, setClipboardActionFilter] = useState<string | null>(null);
    const [currentDiffIndex, setCurrentDiffIndex] = useState<number>(0);
    // Usuaris suspesos per IA a nivell de penalitzacions
    const [iaSuspendedUsers, setIaSuspendedUsers] = useState<Record<string, boolean>>({});
    // Filtre per EXERCICI: mostra només el que l'alumne ha fet en aquesta pràctica/projecte
    // (ignora el filtre per dia). Actiu per defecte perquè un examen sol ser d'un sol dia.
    const [filterByExercise, setFilterByExercise] = useState<boolean>(true);
    const [lockedUsers, setLockedUsers] = useState<Record<string, boolean>>({});
    const [unlocking, setUnlocking] = useState<string | null>(null);
    const [openIdeUsers, setOpenIdeUsers] = useState<Set<string>>(new Set());
    const [startingIdeUser, setStartingIdeUser] = useState<string | null>(null);
    const [stoppingIdeUser, setStoppingIdeUser] = useState<string | null>(null);
    const [fileBrowserVisible, setFileBrowserVisible] = useState(false);
    const [fileBrowserUser, setFileBrowserUser] = useState<{ id: string; name: string } | null>(null);

    // Timeout de màquines i arrencada massiva d'aula
    const [timeoutMinutes, setTimeoutMinutes] = useState<number>(0);
    const [savingTimeout, setSavingTimeout] = useState<boolean>(false);
    const [provisioningAllLoading, setProvisioningAllLoading] = useState<boolean>(false);

    // Examen: mapa id_usuari -> moment d'accés (started_at). Presència = ja ha accedit.
    const [startedExamUsers, setStartedExamUsers] = useState<Record<string, string>>({});
    const [examActionUser, setExamActionUser] = useState<string | null>(null);
    // Avatars per id_usuari (mateixa font que el Dashboard, que es veuen bé).
    const [avatars, setAvatars] = useState<Record<string, string>>({});
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

    // Análisis IA (sospecha de uso de IA generativa)
    const [suspicionMap, setSuspicionMap] = useState<Record<string, any>>({});
    const [analyzingIA, setAnalyzingIA] = useState(false);
    const [iaDetailStudent, setIaDetailStudent] = useState<any | null>(null);
    const [iaDetailVisible, setIaDetailVisible] = useState(false);
    // Modal de progrés orientatiu de l'anàlisi massiva amb IA.
    const [iaProgressVisible, setIaProgressVisible] = useState(false);
    const [iaProgressPercent, setIaProgressPercent] = useState(0);
    const [iaProgressTotal, setIaProgressTotal] = useState(0);
    // Anàlisi IA d'un sol alumne (des del desplegable de la card).
    const [analyzingIaUser, setAnalyzingIaUser] = useState<string | null>(null);

    const fetchIaAnalysis = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/practica/${id_practica}/analisi-ia`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                if (Array.isArray(data)) {
                    const map: Record<string, any> = {};
                    data.forEach((s: any) => { map[String(s.id_usuari)] = s; });
                    setSuspicionMap(map);
                }
            }
        } catch (e) { }
    };

    const runIaAnalysis = async () => {
        // Total orientatiu = nombre d'alumnes de la pràctica (per estimar el progrés).
        const total = Array.isArray(groupedData) ? groupedData.length : 0;
        setIaProgressTotal(total);
        setIaProgressPercent(0);
        setIaProgressVisible(true);
        setAnalyzingIA(true);

        // Barra de progrés ORIENTATIVA: com que el backend analitza tots els alumnes en
        // una sola crida, simulem l'avanç fins ~92% mentre esperem, i el completem al
        // rebre la resposta. El ritme s'ajusta al nombre d'alumnes.
        const perStudentMs = 3000; // estimació d'anàlisi per alumne (més alumnes => més lent)
        const estimatedMs = Math.max(4000, total * perStudentMs);
        const tickMs = 200;
        const target = 92; // no passem d'aquí fins que acabi de veritat
        const increment = (target / (estimatedMs / tickMs));
        const timer = setInterval(() => {
            setIaProgressPercent(prev => {
                if (prev >= target) return prev;
                return Math.min(target, prev + increment);
            });
        }, tickMs);

        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/practica/${id_practica}/analisi-ia`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ analyzed_by: userId ? String(userId) : undefined })
            });
            if (res.ok) {
                const data = await res.json();
                const map: Record<string, any> = {};
                if (Array.isArray(data)) data.forEach((s: any) => { map[String(s.id_usuari)] = s; });
                setSuspicionMap(map);
                const flagged = Object.values(map).filter((v: any) => v.suspicion_level && v.suspicion_level !== 'CAP' && v.suspicion_level !== 'BAIXA').length;
                clearInterval(timer);
                setIaProgressPercent(100);
                message.success({ content: `Anàlisi completada. ${flagged} alumne(s) amb sospita destacable.`, key: "ia-analysis" });
                // Deixem veure el 100% un instant abans de tancar el modal.
                setTimeout(() => setIaProgressVisible(false), 900);
            } else {
                clearInterval(timer);
                setIaProgressVisible(false);
                message.error({ content: "Error en l'anàlisi IA", key: "ia-analysis" });
            }
        } catch (e) {
            clearInterval(timer);
            setIaProgressVisible(false);
            message.error({ content: "Error de connexió en l'anàlisi IA", key: "ia-analysis" });
        } finally {
            setAnalyzingIA(false);
        }
    };

    // Analitza amb IA UN sol alumne (des del desplegable de la card).
    const analitzarAlumneIA = async (record: RecordType) => {
        const uid = String(record.id_usuari);
        setAnalyzingIaUser(uid);
        const msgKey = `ia-uno-${uid}`;
        message.loading({ content: `Analitzant ${record.alumne || uid} amb IA... pot trigar una estona.`, key: msgKey, duration: 0 });
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/practica/${id_practica}/analisi-ia/usuari/${uid}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ analyzed_by: userId ? String(userId) : undefined })
            });
            if (res.ok) {
                const verdict = await res.json();
                if (verdict && verdict.id_usuari !== undefined) {
                    const normalizedVerdict = {
                        ...verdict,
                        evidence_json: verdict.evidence_json ?? (verdict.timeline ? JSON.stringify(verdict.timeline) : null)
                    };
                    setSuspicionMap(prev => ({ ...prev, [uid]: normalizedVerdict }));
                    setIaDetailStudent((prev: any) => (prev && String(prev.student?.id_usuari) === uid) ? { student: record, susp: normalizedVerdict } : prev);
                }
                const lvl = verdict?.suspicion_level || 'CAP';
                message.success({ content: `Anàlisi de ${record.alumne || uid} completada. Sospita: ${lvl} (${verdict?.score ?? 0}/100).`, key: msgKey });
                // Forçar recàrrega per actualitzar totes les dades i l'historial
                fetchIaAnalysis();
                checkDades();
            } else {
                message.error({ content: "Error en l'anàlisi IA de l'alumne", key: msgKey });
            }
        } catch (e) {
            message.error({ content: "Error de connexió en l'anàlisi IA", key: msgKey });
        } finally {
            setAnalyzingIaUser(null);
        }
    };

    // Helpers de sospecha para las tarjetas
    const getSuspicion = (student: any) => suspicionMap[String(student.id_usuari)];
    const suspicionColor = (level: string) => level === 'ALTA' ? '#ff4d4f' : level === 'MITJA' ? '#fa8c16' : level === 'BAIXA' ? '#52c41a' : '#d9d9d9';
    // Guardem els esdeveniments de copiar/pegar de l'alumne del detall IA per poder
    // mostrar el CONTINGUT COMPLET real (no el resum "..." del model) a les evidències.
    const [iaClipboardEvents, setIaClipboardEvents] = useState<any[]>([]);
    // Modal per veure el contingut sencer d'un pegat concret.
    const [pasteFullVisible, setPasteFullVisible] = useState(false);
    const [pasteFullContent, setPasteFullContent] = useState<{ text: string; ts?: string; length?: number } | null>(null);

    // Suspèn l'alumne per ús d'IA: aplica OVERRIDE nota 0 (es_ia) amb el missatge del sistema.
    const [suspendingIa, setSuspendingIa] = useState(false);
    const confirmSuspendrePerIA = (student: any) => {
        if (!student) return;
        Modal.confirm({
            title: 'Suspendre per ús d\'IA generativa?',
            content: `S'aplicarà una penalització que fixa la nota de ${student.alumne || student.id_usuari} a 0 en aquesta pràctica. L'alumne veurà un missatge automàtic del sistema indicant la detecció. La penalització es manté encara que torni a enviar el codi.`,
            okText: 'Suspendre (nota 0)',
            okButtonProps: { danger: true },
            cancelText: 'Cancel·lar',
            onOk: async () => {
                setSuspendingIa(true);
                try {
                    const ok = await SuspendrePerIA(id_practica + "", String(student.id_usuari));
                    if (ok) {
                        message.success(`${student.alumne || student.id_usuari} suspès per ús d'IA (nota 0)`);
                        setIaDetailVisible(false);
                        setIaDetailStudent(null);
                        checkDades();
                        fetchIaPenalties();
                    } else {
                        message.error("Error al suspendre l'alumne");
                    }
                } catch (e) {
                    message.error("Error de connexió");
                } finally {
                    setSuspendingIa(false);
                }
            }
        });
    };

    const openIaDetail = async (student: any) => {
        const uid = String(student.id_usuari);
        let susp = getSuspicion(student);
        setIaDetailStudent({ student, susp });
        setIaClipboardEvents([]);
        setIaDetailVisible(true);

        try {
            const token = localStorage.getItem('authToken');
            const promises: Promise<any>[] = [
                fetch(`${baseUrl}:8061/telemetry/admin/student/${student.id_usuari}/clipboard`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/jutge/practica/${id_practica}/analisi-ia`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
            ];

            const [clipRes, iaRes] = await Promise.all(promises);

            if (clipRes && clipRes.ok) {
                const clipData = await clipRes.json();
                setIaClipboardEvents(Array.isArray(clipData) ? clipData : []);
            }

            if (iaRes && iaRes.ok) {
                const iaData = await iaRes.json();
                if (Array.isArray(iaData)) {
                    const map: Record<string, any> = {};
                    iaData.forEach((s: any) => { map[String(s.id_usuari)] = s; });
                    setSuspicionMap(prev => ({ ...prev, ...map }));
                    const found = iaData.find((x: any) => String(x.id_usuari) === uid);
                    if (found) {
                        setIaDetailStudent({ student, susp: found });
                    }
                }
            }
        } catch (e) {
            /* si falla, es manté el que ja tenim a memòria */
        }
    };

    // Donada una evidència del timeline, intenta trobar el pegat real més proper per hora.
    const findClipboardForEvidence = (ev: any): any | null => {
        if (!iaClipboardEvents || iaClipboardEvents.length === 0) return null;
        const tsStr = ev?.ts || ev?.event_ts;
        const evT = tsStr ? dayjs(tsStr) : null;
        const tipus = String(ev?.tipus || ev?.type || '').toUpperCase();

        const actionOf = (c: any) => String(c.action_type || '').toLowerCase();
        const isPaste = (c: any) => { const a = actionOf(c); return a.includes('paste') || a.includes('enganx'); };
        const isCopy = (c: any) => { const a = actionOf(c); return a.includes('copy') || a.includes('copia') || a.includes('cut') || a.includes('tall'); };

        // Pool segons el tipus d'evidència: PASTE -> pegats; COPY -> còpies/retalls.
        let pool: any[];
        if (tipus === 'PASTE') {
            pool = iaClipboardEvents.filter(isPaste);
        } else if (tipus === 'COPY') {
            pool = iaClipboardEvents.filter(isCopy);
        } else {
            pool = iaClipboardEvents;
        }
        if (pool.length === 0) pool = iaClipboardEvents; // fallback: qualsevol event de portapapers

        if (!evT || !evT.isValid()) {
            // Sense hora fiable: agafem l'event amb més contingut com a millor aposta.
            return pool.reduce((best, c) => {
                const len = Number(c.content_length ?? (c.content_text ? String(c.content_text).length : 0));
                const bestLen = best ? Number(best.content_length ?? (best.content_text ? String(best.content_text).length : 0)) : -1;
                return len > bestLen ? c : best;
            }, null as any);
        }
        // Amb hora: el clipboard amb event_ts més proper (dins d'una finestra raonable).
        let best: any = null;
        let bestDiff = Number.MAX_SAFE_INTEGER;
        for (const c of pool) {
            if (!c.event_ts) continue;
            const diff = Math.abs(dayjs(c.event_ts).valueOf() - evT.valueOf());
            if (diff < bestDiff) { bestDiff = diff; best = c; }
        }
        // Finestra ampliada a ~5 minuts (abans 2) perquè l'hora del model pot ser aproximada.
        return bestDiff <= 300000 ? best : null;
    };

    const openPasteFull = (text: string, ts?: string) => {
        setPasteFullContent({ text: text || '', ts, length: (text || '').length });
        setPasteFullVisible(true);
    };

    const fetchTelemetrySessions = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/telemetry/admin/sessions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                if (Array.isArray(data)) {
                    const map: Record<string, any> = {};
                    data.forEach((s: any) => { map[String(s.id_usuari)] = s; });
                    setTelemetrySessions(map);
                }
            }
        } catch (e) { }
    };

    const fetchLocks = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/locks`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setLockedUsers(data || {});
            }
        } catch (e) { }
    };

    const fetchOpenIdes = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/sessions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setOpenIdeUsers(new Set(Object.keys(data || {}).map(String)));
            }
        } catch (e) { }
    };

    // Avatars: mateixa font que el Dashboard (GetRankingsUsuariId), que es veuen bé.
    // El camp 'avatar' que arriba dels enviaments (TO_BASE64) no es renderitza correctament.
    const fetchAvatars = async () => {
        try {
            const data = await GetRankingsUsuariId(userId + "");
            if (data) {
                const rankingData = Array.isArray(data) ? data : (data.ranking || []);
                const map: Record<string, string> = {};
                rankingData.forEach((r: any) => {
                    const uid = r.id_usuari || r.id;
                    if (uid && r.avatar) map[String(uid)] = r.avatar;
                });
                setAvatars(map);
            }
        } catch (e) { /* noop */ }
    };

    // Examen: alumnes que JA han accedit a l'examen d'aquesta pràctica (tenen fila a
    // jutge.examen_alumne). Aquests NO veuen el botó "Iniciar exàmen".
    const fetchExamStudents = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${id_practica}/students`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                const arr = Array.isArray(data) ? data : [];
                const map: Record<string, string> = {};
                arr.forEach((s: any) => { if (s && s.id !== undefined) map[String(s.id)] = s.started_at; });
                setStartedExamUsers(map);
            }
        } catch (e) { }
    };

    const fetchIaPenalties = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/practica/${id_practica}/penalitzacions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                const arr = Array.isArray(data) ? data : [];
                const map: Record<string, boolean> = {};
                arr.forEach((p: any) => {
                    if (Number(p.es_ia) === 1 && p.id_usuari !== undefined) {
                        map[String(p.id_usuari)] = true;
                    }
                });
                setIaSuspendedUsers(map);
            }
        } catch (e) { }
    };

    const fetchIdeTimeout = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/timeout`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                if (typeof data.timeoutMinutes === 'number') {
                    setTimeoutMinutes(data.timeoutMinutes);
                }
            }
        } catch (err) {
            console.error("Error fetching IDE timeout", err);
        }
    };

    const handleSaveTimeout = async (value: number) => {
        setSavingTimeout(true);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/timeout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ timeoutMinutes: value })
            });
            if (res.ok) {
                setTimeoutMinutes(value);
                if (value === 0) {
                    message.success("Duració de màquines restablerta al valor per defecte (1h normal / 4h examen)");
                } else {
                    message.success(`Duració de màquines fixada en ${value} minuts`);
                }
            } else {
                message.error("Error al desar la duració de les màquines");
            }
        } catch (err) {
            console.error("Error updating IDE timeout", err);
            message.error("Error de connexió");
        } finally {
            setSavingTimeout(false);
        }
    };

    const handleProvisionAllClassroom = async () => {
        const studentsToStart = groupedData || [];
        if (studentsToStart.length === 0) {
            message.warning("No hi ha alumnes en aquesta pràctica.");
            return;
        }

        setProvisioningAllLoading(true);
        const token = localStorage.getItem('authToken');
        let successCount = 0;

        try {
            message.loading({ content: `Iniciant contenidors per a ${studentsToStart.length} alumnes...`, key: 'bulk-ide', duration: 0 });
            const pracParam = id_practica ? `&id_practica=${id_practica}` : '';
            const aulaParam = (practica?.id_aula || (studentsToStart[0] as any)?.idAula) ? `&id_aula=${practica?.id_aula || (studentsToStart[0] as any)?.idAula}` : '';
            for (const s of studentsToStart) {
                const uid = String(s.id_usuari);
                const sAulaParam = (s as any)?.idAula ? `&id_aula=${(s as any).idAula}` : aulaParam;
                try {
                    const res = await fetch(`${baseUrl}:8061/jutge/theia/port?id_usuari=${uid}&admin=true${pracParam}${sAulaParam}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (res.ok) successCount++;
                } catch (e) {
                    console.error("Error starting IDE for", uid, e);
                }
            }

            if (successCount === studentsToStart.length) {
                message.success({ content: `Tots els contenidors iniciats correctament (${successCount}/${studentsToStart.length})`, key: 'bulk-ide' });
            } else if (successCount > 0) {
                message.warning({ content: `Iniciats ${successCount} de ${studentsToStart.length} contenidors`, key: 'bulk-ide' });
            } else {
                message.error({ content: "Error en iniciar els contenidors", key: 'bulk-ide' });
            }
            setTimeout(() => {
                fetchOpenIdes();
                fetchTelemetrySessions();
            }, 2000);
        } catch (e) {
            message.error({ content: "Error de connexió", key: 'bulk-ide' });
        } finally {
            setProvisioningAllLoading(false);
        }
    };

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            GetPractica(id_practica + '').then(res => {
                if (res) setPractica(Array.isArray(res) ? res[0] : res);
            });
            fetchLocks();
            fetchOpenIdes();
            fetchTelemetrySessions();
            fetchIaAnalysis();
            fetchIaPenalties();
            fetchExamStudents();
            fetchAvatars();
            fetchIdeTimeout();

            const interval = setInterval(() => {
                if (!document.hidden) {
                    fetchLocks();
                    fetchOpenIdes();
                    fetchTelemetrySessions();
                    fetchExamStudents();
                    fetchIaPenalties();
                }
            }, 10000);
            return () => clearInterval(interval);
        }
        // eslint-disable-next-line
    }, [id_practica, isLoggedIn]);

    UseWebSocketSubscription(
        isLoggedIn ? ['/topic/exam/locks', '/topic/ide/admin'] : [],
        (topic: string, data: any) => {
            if (topic === '/topic/ide/admin') {
                fetchOpenIdes();
            } else if (data && data.idUsuari !== undefined) {
                setLockedUsers(prev => ({ ...prev, [data.idUsuari]: data.locked }));
            }
        }
    );

    const isLocked = (student: any) => !!lockedUsers[String(student.id_usuari)];
    const hasOpenIde = (student: any) => openIdeUsers.has(String(student.id_usuari));

    const handleStartStudentIde = async (student: any) => {
        const uid = String(student.id_usuari);
        setStartingIdeUser(uid);
        const token = localStorage.getItem('authToken');
        try {
            message.loading({ content: `Iniciant màquina per ${student.alumne || uid}...`, key: `ide-${uid}`, duration: 0 });
            const pracParam = id_practica ? `&id_practica=${id_practica}` : '';
            const aulaParam = (practica?.id_aula || student?.idAula) ? `&id_aula=${practica?.id_aula || student?.idAula}` : '';
            const res = await fetch(`${baseUrl}:8061/jutge/theia/port?id_usuari=${uid}&admin=true${pracParam}${aulaParam}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success({ content: `Màquina iniciada per ${student.alumne || uid}`, key: `ide-${uid}` });
                fetchOpenIdes();
            } else {
                message.error({ content: "Error en iniciar la màquina", key: `ide-${uid}` });
            }
        } catch (e) {
            message.error({ content: "Error de connexió", key: `ide-${uid}` });
        } finally {
            setStartingIdeUser(null);
        }
    };

    const handleStopStudentIde = async (student: any) => {
        const uid = String(student.id_usuari);
        setStoppingIdeUser(uid);
        const token = localStorage.getItem('authToken');
        try {
            message.loading({ content: `Aturant màquina de ${student.alumne || uid}...`, key: `stop-${uid}`, duration: 0 });
            const res = await fetch(`${baseUrl}:8061/jutge/ide/admin/sessions/${uid}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success({ content: `Màquina de ${student.alumne || uid} aturada`, key: `stop-${uid}` });
                fetchOpenIdes();
            } else {
                message.error({ content: "Error en aturar la màquina", key: `stop-${uid}` });
            }
        } catch (e) {
            message.error({ content: "Error de connexió", key: `stop-${uid}` });
        } finally {
            setStoppingIdeUser(null);
        }
    };

    const openStudentFileBrowser = (student: any) => {
        setFileBrowserUser({
            id: String(student.id_usuari),
            name: student.alumne || String(student.id_usuari)
        });
        setFileBrowserVisible(true);
    };

    // Examen: helpers d'estat i accions.
    // get_practica_id retorna el camp com 'isExamen'; acceptem també 'is_examen' per robustesa.
    const isExamPractica = Number(practica?.isExamen ?? practica?.is_examen) === 1;
    const hasStartedExam = (student: any) => Object.prototype.hasOwnProperty.call(startedExamUsers, String(student.id_usuari));
    const startedExamAt = (student: any) => startedExamUsers[String(student.id_usuari)];

    // Reinicia l'accés a l'examen (torna a mostrar el botó "Iniciar exàmen" a l'alumne).
    const resetExamStudent = async (student: any) => {
        const uid = String(student.id_usuari);
        setExamActionUser(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${id_practica}/reset/user/${uid}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success(`Accés a l'examen reiniciat per a ${student.alumne || uid}`);
                setStartedExamUsers(prev => {
                    const next = { ...prev };
                    delete next[uid];
                    return next;
                });
            } else {
                message.error("Error al reiniciar l'accés a l'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setExamActionUser(null);
        }
    };

    // Acció inversa: marca l'alumne com que ja ha accedit (li OCULTA el botó "Iniciar exàmen").
    const markExamStudent = async (student: any) => {
        const uid = String(student.id_usuari);
        setExamActionUser(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${id_practica}/mark/user/${uid}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success(`Botó d'examen ocultat per a ${student.alumne || uid}`);
                setStartedExamUsers(prev => ({ ...prev, [uid]: new Date().toISOString() }));
            } else {
                message.error("Error al ocultar el botó d'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setExamActionUser(null);
        }
    };

    const confirmResetExam = (student: any) => {
        Modal.confirm({
            title: `Reiniciar l'accés a l'examen?`,
            content: `${student.alumne || student.id_usuari} tornarà a veure el botó "Iniciar exàmen" i podrà tornar a entrar a l'examen.`,
            okText: 'Reiniciar',
            okButtonProps: { danger: true },
            cancelText: 'Cancel·lar',
            onOk: () => resetExamStudent(student)
        });
    };

    // "Acabar examen": oculta el botó a TOTS els alumnes que encara el veuen (no iniciats).
    const [finishingExam, setFinishingExam] = useState(false);
    const finishExamForAll = async (pendingIds: string[]) => {
        if (pendingIds.length === 0) {
            message.info("Tots els alumnes ja tenen el botó ocultat.");
            return;
        }
        setFinishingExam(true);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${id_practica}/mark/all`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ ids: pendingIds })
            });
            if (res.ok) {
                message.success(`Examen acabat: botó ocultat per a ${pendingIds.length} alumne(s).`);
                setStartedExamUsers(prev => {
                    const next = { ...prev };
                    const now = new Date().toISOString();
                    pendingIds.forEach(id => { next[id] = now; });
                    return next;
                });
            } else {
                message.error("Error en acabar l'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setFinishingExam(false);
        }
    };

    const confirmFinishExam = (pendingIds: string[]) => {
        Modal.confirm({
            title: 'Acabar l\'examen per a tothom?',
            content: `S'ocultarà el botó "Iniciar exàmen" a ${pendingIds.length} alumne(s) que encara el veuen. No podran (tornar a) entrar a l'examen tret que els reiniciïs individualment.`,
            okText: 'Acabar examen',
            okButtonProps: { danger: true },
            cancelText: 'Cancel·lar',
            onOk: () => finishExamForAll(pendingIds)
        });
    };

    const unlockStudent = async (student: any) => {
        const uid = String(student.id_usuari);
        setUnlocking(uid);
        try {
            const token = localStorage.getItem('authToken');
            // Nombre del profe que desbloquea (para dejar constancia en el historial).
            let actorNom: string | undefined;
            try {
                const u = JSON.parse(localStorage.getItem('user') || '{}');
                actorNom = [u?.nom, u?.cognoms].filter(Boolean).join(' ').trim() || undefined;
            } catch (_) { /* noop */ }
            const res = await fetch(`${baseUrl}:8061/jutge/exam/unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({
                    id_usuari: uid,
                    actor_id: userId ? String(userId) : undefined,
                    actor_nom: actorNom,
                    id_practica: id_practica ? String(id_practica) : undefined
                })
            });
            if (res.ok) {
                message.success(`IDE desbloquejat per a ${student.alumne || uid}`);
                setLockedUsers(prev => ({ ...prev, [uid]: false }));
            } else {
                message.error("Error al desbloquejar l'IDE");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setUnlocking(null);
        }
    };

    const getStudentTelemetryStatus = (student: any): { status: 'activo' | 'conectado' | 'desconectado'; session?: any } => {
        const uid = String(student.id_usuari);
        const session = telemetrySessions[uid];
        if (!session) return hasOpenIde(student) ? { status: 'conectado' } : { status: 'desconectado' };
        if (!session.online) return hasOpenIde(student) ? { status: 'conectado', session } : { status: 'desconectado', session };
        if (session.last_edits > 0) return { status: 'activo', session };
        return { status: 'conectado', session };
    };

    function formatDateTime(iso?: string): string {
        if (!iso) return '—';
        const dj = dayjs(iso);
        if (!dj.isValid()) return iso;
        return dj.toDate().toLocaleString();
    }

    const openTelemetryDetail = async (student: any) => {
        setTelemetryStudent(student);
        setTelemetryModalVisible(true);
        setSelectedFileFilter(null);
        setClipboardActionFilter(null);
        setActiveTelemetryTabKey('timeline');
        setTelemetryDate(dayjs());
        setTelemetryEvents([]);
        setTelemetryClipboardEvents([]);
        setTelemetryLockEvents([]);
        setTelemetryLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const uid = student.id_usuari;
            const [res, clipRes, lockRes] = await Promise.all([
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/clipboard`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/lock-events`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
            ]);
            if (res.ok) {
                const data = await res.json();
                setTelemetryEvents(Array.isArray(data) ? data : []);
            }
            if (clipRes.ok) {
                const clipData = await clipRes.json();
                setTelemetryClipboardEvents(Array.isArray(clipData) ? clipData : []);
            }
            if (lockRes.ok) {
                const lockData = await lockRes.json();
                setTelemetryLockEvents(Array.isArray(lockData) ? lockData : []);
            }
        } catch (e) {
        } finally {
            setTelemetryLoading(false);
        }
    };


    const isTodaySelected = telemetryDate.isSame(dayjs(), 'day');

    // Nom del projecte/carpeta d'aquesta pràctica (per filtrar la telemetria per exercici).
    const practicaProjectName = (practica?.nom || '').trim();

    // Normalitza noms de projecte per comparar (Theia pot substituir espais/accents).
    const normalizeName = (s: string) => (s || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();

    const matchesThisExercisePractica = (ev: any) => {
        // Clipboard i locks porten id_practica: comparem directament.
        if (ev.id_practica !== undefined && ev.id_practica !== null) {
            return String(ev.id_practica) === String(id_practica);
        }
        return false;
    };

    const matchesThisExerciseProject = (ev: any) => {
        // Telemetria porta 'project' (= nom de la carpeta a l'IDE). Comparem normalitzat.
        if (!practicaProjectName) return true; // sense nom de referència, no filtrem
        const proj = normalizeName(String(ev.project || ''));
        const target = normalizeName(practicaProjectName);
        if (!proj) return false;
        return proj === target || proj.includes(target) || target.includes(proj);
    };

    const displayedTelemetryEvents = useMemo(() => {
        return telemetryEvents.filter(ev => {
            if (filterByExercise) return matchesThisExerciseProject(ev);
            if (!ev.event_ts) return false;
            const d = dayjs(ev.event_ts);
            return d.isValid() && d.isSame(telemetryDate, 'day');
        });
        // eslint-disable-next-line
    }, [telemetryEvents, telemetryDate, filterByExercise, practicaProjectName]);

    // Rang temporal de l'exercici: del primer al darrer heartbeat de telemetria dels
    // fitxers d'aquest projecte. S'usa per filtrar copiar/pegar i bloquejos (que no
    // sempre porten un id_practica fiable), capturant el que va passar DURANT l'examen.
    const exerciseTimeRange = useMemo(() => {
        const times: number[] = [];
        telemetryEvents.forEach(ev => {
            if (matchesThisExerciseProject(ev) && ev.event_ts) {
                const t = dayjs(ev.event_ts).valueOf();
                if (!isNaN(t)) times.push(t);
            }
        });
        if (times.length === 0) return null;
        const margin = 10 * 60 * 1000; // ±10 min de marge als extrems
        return { from: Math.min(...times) - margin, to: Math.max(...times) + margin };
        // eslint-disable-next-line
    }, [telemetryEvents, practicaProjectName]);

    const inExerciseRange = (ev: any) => {
        if (!ev.event_ts) return false;
        if (!exerciseTimeRange) return false; // sense telemetria de l'exercici, no mostrem res
        const t = dayjs(ev.event_ts).valueOf();
        return !isNaN(t) && t >= exerciseTimeRange.from && t <= exerciseTimeRange.to;
    };

    // Copiar/Pegar: per exercici (rang temporal de l'examen) o pel dia seleccionat.
    const displayedClipboardEvents = useMemo(() => {
        return telemetryClipboardEvents.filter(ev => {
            if (filterByExercise) return inExerciseRange(ev);
            if (!ev.event_ts) return false;
            const d = dayjs(ev.event_ts);
            return d.isValid() && d.isSame(telemetryDate, 'day');
        });
        // eslint-disable-next-line
    }, [telemetryClipboardEvents, telemetryDate, filterByExercise, exerciseTimeRange]);

    // Bloqueos IDE: per exercici (rang temporal de l'examen) o pel dia seleccionat.
    const displayedLockEvents = useMemo(() => {
        return telemetryLockEvents.filter(ev => {
            if (filterByExercise) return inExerciseRange(ev);
            if (!ev.event_ts) return false;
            const d = dayjs(ev.event_ts);
            return d.isValid() && d.isSame(telemetryDate, 'day');
        });
        // eslint-disable-next-line
    }, [telemetryLockEvents, telemetryDate, filterByExercise, exerciseTimeRange]);

    const availableTelemetryFiles = useMemo(() => {
        const fileMap: Record<string, { count: number; edits: number; language?: string }> = {};
        displayedTelemetryEvents.forEach(ev => {
            const f = ev.file || '(Sense fitxer)';
            if (!fileMap[f]) fileMap[f] = { count: 0, edits: 0, language: ev.language };
            fileMap[f].count += 1;
            fileMap[f].edits += (ev.edits || 0);
            if (!fileMap[f].language && ev.language) fileMap[f].language = ev.language;
        });
        return fileMap;
    }, [displayedTelemetryEvents]);

    const eventsFilteredByFile = useMemo(() => {
        if (!selectedFileFilter) return displayedTelemetryEvents;
        return displayedTelemetryEvents.filter(ev => (ev.file || '(Sense fitxer)') === selectedFileFilter);
    }, [displayedTelemetryEvents, selectedFileFilter]);

    // Agrupación de timeline idéntica a ActivitatsIdEstadistiques
    const groupedTelemetryItems = useMemo(() => {
        const getEvStatus = (ev: any): 'activo' | 'conectado' | 'desconectado' => {
            const isOnline = Number(ev.active) === 1 || Number(ev.focused) === 1;
            if (!isOnline) return 'desconectado';
            if ((ev.edits || 0) > 0 || (ev.runs || 0) > 0 || (ev.debugs || 0) > 0) return 'activo';
            return 'conectado';
        };

        const result: any[] = [];
        let i = 0;
        const events = eventsFilteredByFile;

        while (i < events.length) {
            const ev = events[i];
            const evStatus = getEvStatus(ev);
            const hasEditsOrExec = (ev.edits > 0) || ((ev.runs || 0) > 0) || ((ev.debugs || 0) > 0);

            let prevSnippet: string | null = null;
            let hasCodeChange = false;

            if (ev.code_snippet) {
                for (let k = i + 1; k < events.length; k++) {
                    if (events[k].code_snippet && (!ev.file || events[k].file === ev.file)) {
                        prevSnippet = events[k].code_snippet || null;
                        break;
                    }
                }
                if (ev.edits > 0 || (prevSnippet !== null && prevSnippet !== ev.code_snippet)) {
                    hasCodeChange = true;
                }
            }

            if (hasEditsOrExec || hasCodeChange) {
                result.push({
                    isGroup: false,
                    representativeEvent: ev,
                    count: 1,
                    startTs: ev.event_ts,
                    endTs: ev.event_ts,
                    totalActiveSeconds: ev.active_seconds || 0,
                    eventStatus: evStatus,
                    file: ev.file,
                    files: ev.file ? [ev.file] : [],
                    language: ev.language,
                    project: ev.project,
                    hasCodeChange,
                    prevSnippet
                });
                i++;
                continue;
            }

            const fileSet = new Set<string>();
            if (ev.file) fileSet.add(ev.file);
            let groupCount = 1;
            let totalActiveSecs = ev.active_seconds || 0;
            let lastEventTs = ev.event_ts;
            let j = i + 1;

            while (j < events.length) {
                const nextEv = events[j];
                const nextHasEdits = (nextEv.edits > 0) || ((nextEv.runs || 0) > 0) || ((nextEv.debugs || 0) > 0);
                const nextStatus = getEvStatus(nextEv);

                if (nextHasEdits || nextStatus !== evStatus) break;
                if (nextEv.file) fileSet.add(nextEv.file);
                groupCount++;
                totalActiveSecs += (nextEv.active_seconds || 0);
                lastEventTs = nextEv.event_ts;
                j++;
            }

            result.push({
                isGroup: groupCount > 1,
                representativeEvent: ev,
                count: groupCount,
                startTs: lastEventTs,
                endTs: ev.event_ts,
                totalActiveSeconds: totalActiveSecs,
                eventStatus: evStatus,
                file: ev.file,
                files: Array.from(fileSet),
                language: ev.language,
                project: ev.project,
                hasCodeChange: false,
                prevSnippet: null
            });

            i = j;
        }

        return result;
    }, [eventsFilteredByFile]);


    const [codeModalVisible, setCodeModalVisible] = useState(false);
    const [codeViewMode, setCodeViewMode] = useState<'diff' | 'current'>('diff');
    const [previousCodeSnippet, setPreviousCodeSnippet] = useState<string | null>(null);
    const [selectedCodeEvent, setSelectedCodeEvent] = useState<any>(null);

    // Llista d'elements del timeline que tenen codi / canvi de codi (per navegar entre ells)
    const diffItems = useMemo(() => {
        return groupedTelemetryItems.filter(item => item.representativeEvent?.code_snippet && item.hasCodeChange);
    }, [groupedTelemetryItems]);

    const openDiffModalAtIndex = (idx: number) => {
        if (idx < 0 || idx >= diffItems.length) return;
        const target = diffItems[idx];
        const ev = target.representativeEvent;
        setCurrentDiffIndex(idx);
        setPreviousCodeSnippet(target.prevSnippet);
        setCodeViewMode(target.prevSnippet ? 'diff' : 'current');
        setSelectedCodeEvent(ev);
        setCodeModalVisible(true);
    };

    const formatDuration = (seconds: number) => {
        if (seconds < 60) return `${seconds}s`;
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}m ${s}s`;
    };

    const checkDades = async () => {
        setLoading(true);
        const [data, rew] = await Promise.all([
            GetPractica(id_practica + ""),
            GetUsuarisRecompensesProblema(id_practica + "", undefined, 'PRACTICA')
        ]);
        setDades(data?.enviaments || []);
        if (rew) setRewardsData(rew);
        setLoading(false);
    };

    function getAvatarSrc(img: string | undefined | null) {
        if (!img || img === "undefined" || img === "null") return undefined;
        if (img === "avatar1.jpg" || img === "/images/avatar1.jpg") return "/images/avatar1.jpg";
        if (img.startsWith("http") || img.startsWith("data:") || img.startsWith("/")) return img;
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        // MySQL TO_BASE64() insereix salts de línia cada 76 caràcters; un data URI amb
        // '\n'/espais no es renderitza, així que els netegem abans de construir-lo.
        const clean = img.replace(/\s/g, "");
        if (!clean) return undefined;
        if (clean.startsWith("/9j/")) return `data:image/jpeg;base64,${clean}`;
        if (clean.startsWith("iVB")) return `data:image/png;base64,${clean}`;
        return `data:image/png;base64,${clean}`;
    }

    const handleImpersonate = async (targetId: string) => {
        try {
            message.loading("Impersonant usuari...");
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost');
            const response = await fetch(`${baseUrl}:8061/login/impersonate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify({ adminId: userId, targetId })
            });

            if (response.ok) {
                const data = await response.json();
                const { token, permisos } = data;

                let alu = DefaultAulumneInfo;
                if (permisos && permisos.length > 0) {
                    const res = await GetAlumneId(permisos[0].id, token);
                    if (res) alu = res;
                }

                if (!localStorage.getItem('adminToken')) {
                    localStorage.setItem('adminToken', localStorage.getItem('authToken') || '');
                    localStorage.setItem('admin_userId', localStorage.getItem('userId') || '');
                    localStorage.setItem('admin_user', localStorage.getItem('user') || '');
                    localStorage.setItem('admin_userPermisos', localStorage.getItem('userPermisos') || '');
                    localStorage.setItem('admin_alumneInfo', localStorage.getItem('alumneInfo') || '');
                }

                localStorage.setItem('authToken', token);

                setLoggedIn(true);
                setUserId(String(permisos[0].id));
                setUser(permisos[0]);
                setUserPermisos(permisos);
                setAlumneInfo(alu);

                message.success('Impersonant...');
                window.location.reload();

            } else {
                message.error('Error al impersonar');
            }
        } catch (e) {
            console.error(e);
            message.error('Error de connexió');
        }
    };

    const openPenaltyModal = (record: RecordType, mode: 'subtract' | 'add' = 'subtract') => {
        setSelectedUserForPenalty(record);
        setInitialMode(mode);
        setIsPenaltyModalOpen(true);
    };

    const groupByUser = (enviaments: any[]) => {
        if (!enviaments || enviaments.length === 0) return [];
        const grouped: Record<string, any[]> = {};
        for (const item of enviaments) {
            if (!item || item.id_usuari === undefined || item.id_usuari === null) continue;
            if (!grouped[item.id_usuari]) grouped[item.id_usuari] = [];
            grouped[item.id_usuari].push(item);
        }

        return Object.entries(grouped).map(([id_usuari, items]) => {
            const firstItem = items[0];
            const fileMap = new Map<string, string>();
            const getFileName = (path: string) => {
                if (!path) return "";
                return path.split(/[/\\]/).pop() || path;
            };

            items.forEach(i => {
                if (i.fitxer_nom && i.codi) {
                    fileMap.set(getFileName(i.fitxer_nom), i.codi);
                } else if (i.codi) {
                    fileMap.set("Main.java", i.codi);
                }
            });
            const files = Array.from(fileMap.entries()).map(([name, content]) => ({ name, content }));

            const jsonResult = items.find(i => i.json)?.json;
            let parsedJson = null;
            if (jsonResult) {
                try {
                    parsedJson = JSON.parse(jsonResult);
                } catch (e) { }
            }

            const firstValidTest = items.find(i => i.nom !== "Sense test" && i.estat && i.estat !== "PENALITY");
            const totalPenal = items
                .filter(i => i.estat === "PENALITY")
                .reduce((sum, i) => sum + (i.nota || 0), 0);

            const hasSubmission = !!parsedJson || items.some(i => i.estat && i.nom !== "Sense test");

            let baseNota = firstValidTest ? firstValidTest.nota || 0 : 0;
            let correctCount = 0;
            let incorrectCount = 0;

            if (hasSubmission) {
                if (parsedJson && parsedJson.results) {
                    const res = parsedJson.results;
                    correctCount = res.filter((r: any) => r.status === "PASSED").length;
                    incorrectCount = res.filter((r: any) => r.status === "FAILED").length;
                    if (parsedJson.output) {
                        const match = parsedJson.output.match(/NOTA GLOBAL:\s*([\d\.,]+)/);
                        if (match) {
                            baseNota = parseFloat(match[1].replace(',', '.'));
                        }
                    }
                } else {
                    correctCount = items.filter(i => i.estat && i.nom !== "Sense test" && (i.message === "OK" || i.estat === "PASSED")).length;
                    incorrectCount = items.filter(i => i.estat && i.nom !== "Sense test" && i.message !== "OK" && i.estat !== "PENALITY").length;
                }
            }

            let finalNota = 0;
            if (hasSubmission) {
                // El proc get_practica_id ya devuelve el camp 'nota' de l'enviament amb les
                // penalitzacions aplicades (OVERRIDE/ADJUST). Té prioritat sobre el $.nota
                // del json de l'enviament (que és la nota base dels tests, sense penalitzar).
                if (firstItem && firstItem.nota !== undefined && firstItem.nota !== null) {
                    finalNota = Number(firstItem.nota);
                } else if (parsedJson && typeof parsedJson.nota !== 'undefined') {
                    finalNota = parsedJson.nota;
                } else {
                    finalNota = baseNota + totalPenal * 10;
                }
            }

            const isSuspendedByIa = !!iaSuspendedUsers[String(id_usuari)] ||
                items.some(i => Number(i.es_ia) === 1 || Boolean(i.esIa));

            return {
                id_usuari,
                alumne: firstItem.alumne,
                avatar: firstItem.avatar,
                correctes: correctCount,
                json: firstItem.json,
                incorrectes: incorrectCount,
                nota: finalNota < 0 ? 0 : finalNota,
                enviaments: items,
                hasTests: hasSubmission,
                idAula: firstItem.idAula,
                nomaula: firstItem.nomaula,
                codi: firstItem.codi,
                files: files,
                output: firstItem.output || (parsedJson ? parsedJson.output : ""),
                origen: firstItem.origen,
                tipus: firstItem.rol,
                isSuspendedByIa
            };
        });
    };

    const groupedData = groupByUser(dades).filter(d => String(d.tipus) === "2");

    const [searchText, setSearchText] = useState("");
    const filteredData = searchText
        ? groupedData.filter(d => d.alumne?.toLowerCase().includes(searchText.toLowerCase()))
        : groupedData;

    // Stats
    const totalStudents = groupedData.length;

    // Alumnos (tipus === "2")
    const usersAlumnes = groupedData.filter(d => d.tipus === 2);
    const totalAlumnes = usersAlumnes.length;
    const submittedAlumnes = usersAlumnes.filter(d => d.hasTests).length;
    const passedAlumnes = usersAlumnes.filter(d => d.nota >= 50).length;

    // Profesores (tipus === "1")
    const usersProfes = groupedData.filter(d => d.tipus === 1);
    const totalProfes = usersProfes.length;
    const submittedProfes = usersProfes.filter(d => d.hasTests).length;


    const openCodeModal = (record: RecordType) => {
        setSelectedUserForTests(record);
        setIsTestsModalOpen(true);
    };

    const openIdeModal = async (record: RecordType) => {
        setSelectedUserForIde(record);
        setIsIdeModalOpen(true);
        setIdeLoading(true);
        setIdeUrl("");

        const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
        const token = localStorage.getItem('authToken');

        let currentPractica = practica;
        if (!currentPractica || !currentPractica.nom) {
            const freshPractica = await GetPractica(id_practica + "");
            if (freshPractica) {
                currentPractica = Array.isArray(freshPractica) ? freshPractica[0] : freshPractica;
                setPractica(currentPractica);
            }
        }

        let folderName = currentPractica?.nom || "";

        let attempts = 0;
        const maxAttempts = 30; // 30 attempts * 3s = 90 seconds timeout

        try {
            const aulaParam = (practica?.id_aula || (record as any)?.idAula) ? `&id_aula=${practica?.id_aula || (record as any)?.idAula}` : '';
            while (attempts < maxAttempts) {
                const startRes = await fetch(`${baseUrl}/jutge/theia/port?id_usuari=${record.id_usuari}&folder=${encodeURIComponent(folderName)}&id_practica=${id_practica}${aulaParam}&admin=true`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!startRes.ok) {
                    const errData = await startRes.json();
                    throw new Error(errData.error || "Error al obrir l'IDE.");
                }

                const data = await startRes.json();

                if (data.status === 'provisioning' || data.hostname === 'Pending...' || data.port === 0) {
                    attempts++;
                    // Wait 3 seconds before next poll
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    continue;
                }

                // Success! Construct URL
                const projectName = data.normalizedProjectName;
                let theiaBase = data.httpsUrl || `http://${data.hostname || window.location.hostname}:${data.port}`;
                if (theiaBase.endsWith("/")) theiaBase = theiaBase.slice(0, -1);

                let theiaUrl = projectName
                    ? `${theiaBase}/#/mnt/efs/${record.id_usuari}/${projectName}`
                    : `${theiaBase}/#/mnt/efs/${record.id_usuari}`;

                if (practica?.is_examen === 1) {
                    theiaUrl = `${window.location.origin}/ide/exam-v2?url=${encodeURIComponent(theiaUrl)}&idPractica=${id_practica}`;
                }

                setIdeUrl(theiaUrl);
                setIdeLoading(false);
                return; // Exit loop and function
            }

            throw new Error("S'ha superat el temps d'espera per provisionar l'IDE.");
        } catch (e: any) {
            message.error(`Error: ${e.message}`);
            // Don't close modal yet if it was a timeout, but stop loading
            setIdeLoading(false);
            if (attempts >= maxAttempts) {
                // Option to close or stay at error state
                // setIsIdeModalOpen(false);
            }
        }
    };

    const reevaluarTot = async () => {
        setLoading(true);
        const toEval = groupedData.filter(u => u.hasTests);
        const total = toEval.length;
        message.info(`Iniciant reavaluació de ${total} alumnes...`);

        // Force react update
        await new Promise(r => setTimeout(r, 100));

        let count = 0;
        const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
        const token = localStorage.getItem('authToken');

        for (const u of toEval) {
            count++;
            const msgKey = `reeval-${u.id_usuari}`;
            message.loading({ content: `[${count}/${total}] Reevaluant ${u.alumne}...`, key: msgKey });
            try {
                // Obtenemos el enviament más reciente
                let idEnviamentOrigin = null;
                if (u.enviaments && u.enviaments.length > 0) {
                    const sorted = [...u.enviaments].sort((a, b) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                    idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                }

                if (!idEnviamentOrigin) {
                    // Si no tiene id, lo buscamos en el endpoint de enviaments de este usuario
                    const envRes = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${u.id_usuari}/enviaments`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (envRes.ok) {
                        const envData = await envRes.json();
                        if (envData && envData.length > 0) {
                            const sorted = envData.sort((a: any, b: any) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                            idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                        }
                    }
                }

                if (!idEnviamentOrigin) {
                    throw new Error("No s'ha trobat l'enviament original");
                }

                const response = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${u.id_usuari}/reenviar`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        idEnviamentOrigin: idEnviamentOrigin,
                        filename: "",
                        content: "",
                        files: [],
                        deletedFiles: []
                    })
                });

                if (!response.ok) {
                    let errorMsg = "Error desconegut";
                    try {
                        const errParams = await response.text();
                        try {
                            const errJson = JSON.parse(errParams);
                            errorMsg = errJson.response || errorMsg;
                        } catch (e) {
                            errorMsg = errParams.substring(0, 50);
                        }
                    } catch (e) { }
                    throw new Error(errorMsg);
                }

                console.log(`Reevaluat (reenviament) ${u.alumne}`);
                message.success({ content: `Alumne ${u.alumne} reevaluat OK`, key: msgKey, duration: 2 });
            } catch (e: any) {
                console.error(`Error reevaluant usuari ${u.alumne}`, e);
                message.error({ content: `Error reevaluant ${u.alumne}: ${e.message}`, key: msgKey, duration: 3 });
            }
        }
        message.success("Reavaluació completada.");
        checkDades();
    };

    const loadFilesToNfs = async () => {
        if (!selectedUserForIde) return;
        const msgKey = "load-nfs";
        message.loading({ content: "Carregant fitxers a l'entorn...", key: msgKey, duration: 0 });

        try {
            const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
            const token = localStorage.getItem('authToken');

            let idEnviamentOrigin = null;
            if (selectedUserForIde.enviaments && selectedUserForIde.enviaments.length > 0) {
                const sorted = [...selectedUserForIde.enviaments].sort((a, b) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
            }

            if (!idEnviamentOrigin) {
                const envRes = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${selectedUserForIde.id_usuari}/enviaments`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (envRes.ok) {
                    const envData = await envRes.json();
                    if (envData && envData.length > 0) {
                        const sorted = envData.sort((a: any, b: any) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                        idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                    }
                }
            }

            if (!idEnviamentOrigin) {
                throw new Error("L'alumne no té cap entrega per carregar.");
            }

            const response = await fetch(`${apiUrl}/jutge/ide/admin/sessions/${selectedUserForIde.id_usuari}/practica/${id_practica}/load-enviament`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ idEnviamentOrigin, folderName: practica?.nom })
            });

            if (!response.ok) {
                throw new Error("Error al carregar els fitxers al servidor NFS.");
            }

            message.success({ content: "Fitxers carregats correctament a l'entorn IDE.", key: msgKey });
        } catch (e: any) {
            console.error(e);
            message.error({ content: e.message || "Error al carregar fitxers.", key: msgKey });
        }
    };

    const downloadUltimaEntrega = async (record: RecordType) => {
        try {
            const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
            const token = localStorage.getItem('authToken');

            let idEnviamentOrigin = null;
            if (record.enviaments && record.enviaments.length > 0) {
                const sorted = [...record.enviaments].sort((a, b) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
            }

            if (!idEnviamentOrigin) {
                const envRes = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${record.id_usuari}/enviaments`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (envRes.ok) {
                    const envData = await envRes.json();
                    if (envData && envData.length > 0) {
                        const sorted = envData.sort((a: any, b: any) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                        idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                    }
                }
            }

            if (!idEnviamentOrigin) {
                message.warning("Aquest alumne no té cap entrega per baixar.");
                return;
            }

            message.loading({ content: "Descarregant fitxers...", key: "download_zip" });
            const downloadRes = await fetch(`${apiUrl}/jutge/enviament/${idEnviamentOrigin}/download`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!downloadRes.ok) {
                throw new Error("Error al baixar l'entrega");
            }

            const blob = await downloadRes.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${record.alumne.replace(/[^a-zA-Z0-9]/g, '_')}_entrega_${idEnviamentOrigin}.zip`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            message.success({ content: "Fitxers descarregats correctament", key: "download_zip" });
        } catch (e: any) {
            message.error({ content: e.message || "Error al baixar l'entrega.", key: "download_zip" });
        }
    };

    const evaluarUnoIde = async (record: RecordType) => {
        setEvalInProgress(record.id_usuari);
        const msgKey = `eval-uno-${record.id_usuari}`;
        message.loading({ content: `Iniciant evaluació IDE per ${record.alumne}...`, key: msgKey });

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
            const token = localStorage.getItem('authToken');

            // 1. Ensure IDE is running (Start if necessary)
            message.loading({ content: `Verificant estat del contenidor para ${record.alumne}...`, key: msgKey });
            const aulaParam = (practica?.id_aula || (record as any)?.idAula) ? `&id_aula=${practica?.id_aula || (record as any)?.idAula}` : '';
            const startRes = await fetch(`${baseUrl}/jutge/theia/port?id_usuari=${record.id_usuari}&folder=${encodeURIComponent(practica?.nom || "")}&id_practica=${id_practica}${aulaParam}&admin=true`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!startRes.ok) throw new Error("Error al arrancar el IDE del alumno.");
            const startData = await startRes.json();

            // If it was provisioning, wait a bit or inform the user
            if (startData.status === 'provisioning') {
                message.loading({ content: `Provisionant IDE... (Pots provar de nou en uns segons)`, key: msgKey });
                // We'll proceed anyway as the submit endpoint handles direct EFS access if sidecar is not ready
            }

            // 2. Trigger Evaluation
            const response = await fetch(`${baseUrl}/jutge/ide/practica/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    idPractica: id_practica + '',
                    idUsuari: record.id_usuari + '',
                    folder: practica?.nom,
                    origen: record.origen === 1 ? 'WEB_DESAFIO' : (record.origen === 2 ? 'UNITY' : 'WEB_NORMAL')
                })
            });

            const text = await response.text();
            let data: any = null;
            try { data = JSON.parse(text); } catch (e) { }

            if (!response.ok) {
                message.error({ content: `Error: ${data?.error || text}`, key: msgKey, duration: 4 });
            } else {
                message.success({ content: `Evaluat OK per ${record.alumne}`, key: msgKey, duration: 3 });
                checkDades();
            }
        } catch (e: any) {
            message.error({ content: `Error evaluant alumne: ${e.message}`, key: msgKey, duration: 4 });
        } finally {
            setEvalInProgress(null);
        }
    };

    const evaluarTodoIde = async () => {
        // Filter users by role: only "2" (Student)
        const studentsToEval = groupedData.filter(u => String(u.tipus) === "2");
        const total = studentsToEval.length;
        if (total === 0) {
            message.info("No hi ha alumnes per evaluar.");
            return;
        }

        setIsBulkEvalModalOpen(true);
        setEvalLogs([]);
        setEvalProgress(0);
        setLoading(true);

        const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
        const token = localStorage.getItem('authToken');

        let count = 0;
        let successCount = 0;

        for (const u of studentsToEval) {
            count++;
            const newLog: any = { name: u.alumne, status: 'loading' };
            setEvalLogs(prev => [newLog, ...prev]);

            try {
                const response = await fetch(`${baseUrl}/jutge/ide/practica/submit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        idPractica: id_practica + '',
                        idUsuari: u.id_usuari + '',
                        folder: practica?.nom,
                        origen: u.origen === 1 ? 'WEB_DESAFIO' : (u.origen === 2 ? 'UNITY' : 'WEB_NORMAL')
                    })
                });

                const text = await response.text();
                let data: any = null;
                try { data = JSON.parse(text); } catch (e) { }

                if (!response.ok) {
                    setEvalLogs(prev => prev.map(l => l.name === u.alumne ? { ...l, status: 'warning', msg: data?.error || 'No té fitxers' } : l));
                } else {
                    setEvalLogs(prev => prev.map(l => l.name === u.alumne ? { ...l, status: 'success', msg: 'Evaluat OK' } : l));
                    successCount++;
                }
            } catch (e: any) {
                setEvalLogs(prev => prev.map(l => l.name === u.alumne ? { ...l, status: 'error', msg: e.message } : l));
            }
            setEvalProgress(Math.round((count / total) * 100));
        }

        message.success(`Evaluació IDE completada. OK: ${successCount} de ${total}`);
        setLoading(false);
        checkDades();
    };



    return (
        <div style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
            <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
                <div style={{ minWidth: 260, flexShrink: 0 }}>
                    <Title level={2} style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Seguiment de la Pràctica</Title>
                    <Text type="secondary">Gestió de lliuraments i avaluació</Text>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Input
                        allowClear
                        placeholder="Cercar per nom o cognom"
                        style={{ width: 220 }}
                        value={searchText}
                        onChange={(e: any) => setSearchText(e.target.value)}
                        prefix={<SearchOutlined />}
                    />
                    <Button
                        type="primary"
                        style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                        icon={<PlayCircleOutlined />}
                        onClick={handleProvisionAllClassroom}
                        loading={provisioningAllLoading}
                        disabled={!groupedData || groupedData.length === 0}
                    >
                        Arrencar Màquines Alumnes
                    </Button>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#fff', padding: '2px 10px', borderRadius: '6px', border: '1px solid #d9d9d9' }}>
                        <ClockCircleOutlined style={{ color: '#1890ff', fontSize: 13 }} />
                        <span style={{ fontSize: '12px', fontWeight: 500 }}>Duració:</span>
                        <Select
                            size="small"
                            style={{ width: 145 }}
                            value={timeoutMinutes}
                            loading={savingTimeout}
                            onChange={(val) => handleSaveTimeout(val)}
                        >
                            <Select.Option value={0}>Per defecte (1h / 4h)</Select.Option>
                            <Select.Option value={15}>15 minuts</Select.Option>
                            <Select.Option value={30}>30 minuts</Select.Option>
                            <Select.Option value={45}>45 minuts</Select.Option>
                            <Select.Option value={60}>1 hora</Select.Option>
                            <Select.Option value={90}>1h 30m</Select.Option>
                            <Select.Option value={120}>2 hores</Select.Option>
                            <Select.Option value={180}>3 hores</Select.Option>
                            <Select.Option value={240}>4 hores</Select.Option>
                            <Select.Option value={360}>6 hores</Select.Option>
                            <Select.Option value={480}>8 hores</Select.Option>
                            <Select.Option value={1440}>24 hores (1 dia)</Select.Option>
                        </Select>
                    </div>

                    <Button icon={<BiRefresh />} onClick={checkDades} loading={loading}>Refrescar</Button>
                    <Button
                        type="primary"
                        icon={<RotateRightOutlined />}
                        onClick={() => {
                            const studentsToEval = groupedData.filter(u => String(u.tipus) === "2");
                            Modal.confirm({
                                title: "Confirmar Avaluació Masiva (IDE)",
                                icon: <RotateRightOutlined style={{ color: '#1890ff' }} />,
                                content: (
                                    <div>
                                        <p>Estàs a punt d'avaluar l'entorn de desenvolupament (IDE) de <strong>{studentsToEval.length} alumnes</strong>.</p>
                                        <p style={{ color: '#8c8c8c', fontSize: 13 }}>Aquest procés compilarà i executarà els tests directament des de l'espai de treball de cada alumne.</p>
                                    </div>
                                ),
                                okText: "Sí, avaluar tot",
                                okType: "primary",
                                cancelText: "Cancel·lar",
                                onOk: () => {
                                    evaluarTodoIde();
                                }
                            });
                        }}
                        loading={loading}
                        style={{ background: '#1890ff', borderColor: '#1890ff' }}
                    >
                        Evaluar Tot (IDE)
                    </Button>
                    <Button
                        type="primary"
                        icon={<BiRevision />}
                        onClick={() => {
                            const toEval = groupedData.filter(u => u.hasTests);
                            Modal.confirm({
                                title: "Confirmar Re-avaluació Masiva",
                                icon: <BiRevision style={{ color: JutgeColors.colors.color2, fontSize: 20 }} />,
                                content: (
                                    <div>
                                        <p>Estàs a punt de re-avaluar els lliuraments de <strong>{toEval.length} alumnes</strong> que tenen tests.</p>
                                        <p style={{ color: '#fa8c16', fontSize: 13 }}>⚠️ Es tornaran a executar els tests sobre l'última entrega registrada de cada alumne i s'actualitzaran les notes.</p>
                                    </div>
                                ),
                                okText: "Sí, re-avaluar tot",
                                okType: "danger",
                                cancelText: "Cancel·lar",
                                onOk: () => {
                                    reevaluarTot();
                                }
                            });
                        }}
                        loading={loading}
                        style={{ background: JutgeColors.colors.color2, borderColor: JutgeColors.colors.color2 }}
                    >
                        Re-evaluar Tot
                    </Button>
                    {isExamPractica && (
                        <Tooltip title="Analitza totes les entregues amb IA per detectar possible ús d'IA generativa (copiar/pegar, salts de codi, pèrdues de focus...)">
                            <Button
                                type="primary"
                                icon={<ThunderboltOutlined />}
                                onClick={runIaAnalysis}
                                loading={analyzingIA}
                                style={{ background: '#722ed1', borderColor: '#722ed1' }}
                            >
                                Analitzar amb IA
                            </Button>
                        </Tooltip>
                    )}
                    {props.onClose && (
                        <Button onClick={props.onClose}>
                            Tancar
                        </Button>
                    )}
                </div>
            </div>

            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={8}>
                    <Card bordered={false} style={{ borderRadius: 10 }}>
                        <Statistic title="Alumnes Totals" value={totalAlumnes} prefix={<InboxOutlined />} />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card bordered={false} style={{ borderRadius: 10 }}>
                        <Statistic title="Lliurats (Alumnes)" value={submittedAlumnes} valueStyle={{ color: '#3f8600' }} />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card bordered={false} style={{ borderRadius: 10 }}>
                        <Statistic title="Aprovats (Alumnes)" value={passedAlumnes} suffix={`/ ${submittedAlumnes}`} />
                    </Card>
                </Col>
            </Row>

            {/* Resum de Telemetria en Temps Real (Monitoreo IDE i Contenidors) */}
            {(() => {
                const activeStudents = filteredData.filter(s => getStudentTelemetryStatus(s).status === 'activo');
                const connectedStudents = filteredData.filter(s => getStudentTelemetryStatus(s).status === 'conectado');
                const lockedCount = filteredData.filter(s => isLocked(s)).length;
                return (
                    <Card
                        bordered={false}
                        style={{
                            borderRadius: 10,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            background: '#ffffff',
                            border: '1px solid #e8e8e8',
                            marginBottom: 16
                        }}
                        bodyStyle={{ padding: '10px 16px' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
                            <Space size="middle" wrap>
                                <Tag color="green" icon={<ThunderboltOutlined />} style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6 }}>
                                    <strong>{activeStudents.length}</strong> Actius (escribint codi)
                                </Tag>
                                <Tag color="blue" icon={<DesktopOutlined />} style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6 }}>
                                    <strong>{connectedStudents.length}</strong> Connectats (IDE Theia obert)
                                </Tag>
                                <Tag color="default" style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6 }}>
                                    <strong>{filteredData.length - (activeStudents.length + connectedStudents.length)}</strong> Desconnectats
                                </Tag>
                                {lockedCount > 0 && (
                                    <Tag color="red" icon={<LockOutlined />} style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6 }}>
                                        <strong>{lockedCount}</strong> Bloquejats
                                    </Tag>
                                )}
                            </Space>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    Monitoreig en temps real creuat amb l'IDE
                                </Text>
                                {isExamPractica && (() => {
                                    // Alumnes que encara veuen el botó (no han accedit a l'examen).
                                    // Usem groupedData (tots) i no filteredData perquè "Acabar examen"
                                    // ha d'afectar a tothom, independentment del filtre de cerca.
                                    const pendingIds = groupedData
                                        .filter((s: any) => !hasStartedExam(s))
                                        .map((s: any) => String(s.id_usuari));
                                    return (
                                        <Tooltip title={pendingIds.length > 0
                                            ? `Ocultar el botó "Iniciar exàmen" a ${pendingIds.length} alumne(s) que encara el veuen`
                                            : 'Tots els alumnes ja tenen el botó ocultat'}>
                                            <Button
                                                size="small"
                                                danger
                                                icon={<EyeInvisibleOutlined />}
                                                loading={finishingExam}
                                                disabled={pendingIds.length === 0}
                                                onClick={() => confirmFinishExam(pendingIds)}
                                            >
                                                Acabar examen{pendingIds.length > 0 ? ` (${pendingIds.length})` : ''}
                                            </Button>
                                        </Tooltip>
                                    );
                                })()}
                                <Button
                                    size="small"
                                    icon={<ReloadOutlined />}
                                    onClick={() => { fetchTelemetrySessions(); fetchLocks(); fetchOpenIdes(); }}
                                >
                                    Refrescar IDE
                                </Button>
                            </div>
                        </div>
                    </Card>
                );
            })()}

            {loading ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <Spin size="large" />
                </div>
            ) : (
                <Row gutter={[16, 16]}>
                    {filteredData.map(record => {
                        const stringToColor = (str: string) => {
                            let hash = 0;
                            for (let i = 0; i < str.length; i++) {
                                hash = str.charCodeAt(i) + ((hash << 5) - hash);
                            }
                            const c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
                            return '#' + '00000'.substring(0, 6 - c.length) + c;
                        };

                        const name = record.alumne || 'Anònim';
                        const initials = name.substring(0, 2).toUpperCase();
                        const avatarColor = stringToColor(name);
                        const val = Number(record.nota);
                        const isIaSuspended = !!record.isSuspendedByIa;
                        let color = isIaSuspended ? 'purple' : (val >= 80 ? 'green' : val >= 50 ? 'blue' : val >= 25 ? 'orange' : 'red');

                        const tel = getStudentTelemetryStatus(record);
                        const telStatus = tel.status;
                        const telSession = tel.session;

                        // Borde/sombra de la tarjeta estilo ActivitatsIdEstadistiques:
                        // 1. Bloqueado (rojo)
                        // 2. Telemetría ACTIVO (verde fosforescente/resplandeciente - escribiendo código con la extensión)
                        // 3. Telemetría CONECTADO / Contenedor Theia abierto (azul)
                        // 4. Normal / Desconectado
                        const cardBorderShadow = isLocked(record)
                            ? '0 0 0 2px #ff4d4f'
                            : (telStatus === 'activo'
                                ? '0 0 0 2.5px #52c41a, 0 2px 10px rgba(82, 196, 26, 0.25)'
                                : (telStatus === 'conectado' || hasOpenIde(record)
                                    ? '0 0 0 2px #1890ff'
                                    : '0 2px 8px rgba(0,0,0,0.04)'));

                        return (
                            <Col xs={24} sm={12} md={8} lg={6} xl={4} key={record.id_usuari}>
                                <Card
                                    hoverable
                                    bordered={false}
                                    style={{
                                        borderRadius: 12,
                                        boxShadow: cardBorderShadow,
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        cursor: 'default'
                                    }}
                                    bodyStyle={{ padding: 12, display: 'flex', flexDirection: 'column', height: '100%' }}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: 8 }}>
                                        {/* Avatar (mateixa font que el Dashboard: mapa d'avatars per id_usuari) */}
                                        {(() => {
                                            const avatarSrc = getAvatarSrc(avatars[String(record.id_usuari)] || record.avatar);
                                            return (
                                                <Avatar
                                                    size={56}
                                                    src={avatarSrc}
                                                    style={{
                                                        backgroundColor: avatarSrc ? undefined : avatarColor,
                                                        color: '#fff',
                                                        fontWeight: 'bold',
                                                        fontSize: 18,
                                                        flexShrink: 0,
                                                        border: '1px solid #f0f0f0',
                                                        marginBottom: 6
                                                    }}
                                                >
                                                    {initials}
                                                </Avatar>
                                            );
                                        })()}

                                        {/* Nombre completo (con espacio para verse bien) */}
                                        <Typography.Text
                                            strong
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                                fontSize: 13,
                                                lineHeight: 1.25,
                                                marginBottom: 4,
                                                wordBreak: 'break-word'
                                            }}
                                            title={name}
                                        >
                                            {name}
                                        </Typography.Text>

                                        {/* Etiquetas de rol / origen */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                            {String(record.tipus) === "1" && <Tag color="gold" style={{ margin: 0, padding: '0 4px', lineHeight: '16px', fontSize: 10 }}>PROF</Tag>}
                                            {record.origen === 1 && <Tag color="blue" style={{ margin: 0, padding: '0 4px', lineHeight: '16px', fontSize: 10 }}>Desafío</Tag>}
                                            {record.origen === 2 && <Tag color="purple" style={{ margin: 0, padding: '0 4px', lineHeight: '16px', fontSize: 10 }}>Unity</Tag>}
                                        </div>

                                        {/* Estado de telemetría / bloqueo */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, alignItems: 'center', justifyContent: 'center', marginTop: 3 }}>
                                            {!isLocked(record) && telStatus === 'activo' && (
                                                <Tooltip title={`Escribint codi ara mateix${telSession?.last_file ? ` a ${telSession.last_file}` : ''}. Clica per veure historial.`}>
                                                    <Tag
                                                        color="green"
                                                        icon={<ThunderboltOutlined />}
                                                        style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px', cursor: 'pointer', fontWeight: 'bold' }}
                                                        onClick={() => openTelemetryDetail(record)}
                                                    >
                                                        ACTIU
                                                    </Tag>
                                                </Tooltip>
                                            )}
                                            {!isLocked(record) && telStatus === 'conectado' && (
                                                <Tooltip title="IDE obert (connectat al contenidor Theia). Clica per veure historial.">
                                                    <Tag
                                                        color="blue"
                                                        icon={<DesktopOutlined />}
                                                        style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px', cursor: 'pointer' }}
                                                        onClick={() => openTelemetryDetail(record)}
                                                    >
                                                        IDE
                                                    </Tag>
                                                </Tooltip>
                                            )}
                                            {isLocked(record) && (
                                                <Tooltip title="IDE d'examen bloquejat. Clica per desbloquejar.">
                                                    <Tag
                                                        color="red"
                                                        icon={<LockOutlined />}
                                                        onClick={() => unlockStudent(record)}
                                                        style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px', cursor: 'pointer' }}
                                                    >
                                                        Bloquejat
                                                    </Tag>
                                                </Tooltip>
                                            )}
                                            {(() => {
                                                const susp = getSuspicion(record);
                                                if (!susp || !susp.suspicion_level || susp.suspicion_level === 'CAP') return null;
                                                const lvl = susp.suspicion_level;
                                                const color = lvl === 'ALTA' ? 'red' : lvl === 'MITJA' ? 'orange' : 'green';
                                                return (
                                                    <Tooltip title={`Sospita d'ús d'IA: ${lvl} (${susp.score ?? 0}/100). Clica per veure les evidències.`}>
                                                        <Tag
                                                            color={color}
                                                            icon={<WarningOutlined />}
                                                            style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px', cursor: 'pointer', fontWeight: 'bold' }}
                                                            onClick={() => openIaDetail(record)}
                                                        >
                                                            IA {lvl}
                                                        </Tag>
                                                    </Tooltip>
                                                );
                                            })()}
                                            {/* Estat d'accés a l'examen */}
                                            {isExamPractica && (
                                                hasStartedExam(record) ? (
                                                    <Tooltip title={`L'alumne ja ha accedit a l'examen${startedExamAt(record) ? ` (${dayjs(startedExamAt(record)).format('DD/MM HH:mm')})` : ''}. No veu el botó "Iniciar exàmen".`}>
                                                        <Tag
                                                            color="volcano"
                                                            icon={<PlayCircleOutlined />}
                                                            style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px' }}
                                                        >
                                                            Examen iniciat
                                                        </Tag>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title={`L'alumne encara pot iniciar l'examen (veu el botó "Iniciar exàmen").`}>
                                                        <Tag
                                                            color="default"
                                                            style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px' }}
                                                        >
                                                            Pot iniciar
                                                        </Tag>
                                                    </Tooltip>
                                                )
                                            )}
                                        </div>

                                        {/* Botones (debajo del avatar/nombre, centrados) */}
                                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 8 }}>
                                            <Tooltip title="Veure historial de telemetria i activitat IDE">
                                                <Button
                                                    type="text"
                                                    size="small"
                                                    style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                    icon={<HistoryOutlined style={{ color: '#1890ff', fontSize: 14 }} />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openTelemetryDetail(record);
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Veure recompenses">
                                                <Button
                                                    type="text"
                                                    size="small"
                                                    style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                    icon={<GiftOutlined style={{ color: '#faad14', fontSize: 14 }} />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedStudentRewards({
                                                            student: record,
                                                            rewards: rewardsData.filter((r: any) => String(r.id_usuari) === String(record.id_usuari))
                                                        });
                                                        setRewardsModalVisible(true);
                                                    }}
                                                />
                                            </Tooltip>
                                            <Tooltip title="Impersonar Alumne">
                                                <Button
                                                    type="text"
                                                    size="small"
                                                    style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                    icon={<UserSwitchOutlined style={{ color: '#1890ff', fontSize: 14 }} />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleImpersonate(String(record.id_usuari));
                                                    }}
                                                />
                                            </Tooltip>
                                            {/* Arrencar / Aturar màquina i Explorar fitxers */}
                                            {!hasOpenIde(record) ? (
                                                <Tooltip title="Arrencar màquina (Theia IDE)">
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                        loading={startingIdeUser === String(record.id_usuari)}
                                                        icon={<PlayCircleOutlined style={{ color: '#52c41a', fontSize: 15 }} />}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleStartStudentIde(record);
                                                        }}
                                                    />
                                                </Tooltip>
                                            ) : (
                                                <>
                                                    <Tooltip title="Explorar carpetes i fitxers de l'alumne">
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                            icon={<FolderOpenOutlined style={{ color: '#fa8c16', fontSize: 15 }} />}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openStudentFileBrowser(record);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                    <Popconfirm
                                                        title="Aturar màquina?"
                                                        description="Això apagarà el contenidor Theia de l'alumne."
                                                        onConfirm={(e) => {
                                                            e?.stopPropagation();
                                                            handleStopStudentIde(record);
                                                        }}
                                                        onCancel={(e) => e?.stopPropagation()}
                                                        okText="Sí, aturar"
                                                        cancelText="Cancel·lar"
                                                        okType="danger"
                                                    >
                                                        <Tooltip title="Aturar màquina (Theia IDE)">
                                                            <Button
                                                                type="text"
                                                                size="small"
                                                                danger
                                                                style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                                loading={stoppingIdeUser === String(record.id_usuari)}
                                                                icon={<StopOutlined style={{ color: '#ff4d4f', fontSize: 15 }} />}
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                                                        </Tooltip>
                                                    </Popconfirm>
                                                </>
                                            )}
                                            {/* Accions d'examen: només si la pràctica és un examen */}
                                            {isExamPractica && (
                                                hasStartedExam(record) ? (
                                                    <Tooltip title="Reiniciar l'accés a l'examen (tornar a mostrar el botó a l'alumne)">
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            loading={examActionUser === String(record.id_usuari)}
                                                            style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                            icon={<UndoOutlined style={{ color: '#fa541c', fontSize: 14 }} />}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmResetExam(record);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Ocultar el botó d'examen a l'alumne (marcar com a ja accedit)">
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            loading={examActionUser === String(record.id_usuari)}
                                                            style={{ padding: '0 4px', height: '24px', minWidth: '24px' }}
                                                            icon={<EyeInvisibleOutlined style={{ color: '#8c8c8c', fontSize: 14 }} />}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                markExamStudent(record);
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )
                                            )}
                                        </div>
                                    </div>

                                    {/* Stats and Nota */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 10, background: '#fafafa', padding: '8px 10px', borderRadius: 8 }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography.Text type="secondary" style={{ fontSize: 11, fontWeight: 500 }}>NOTA GLOBAL</Typography.Text>
                                            {record.json || isIaSuspended ? (
                                                <Tag
                                                    color={isIaSuspended ? 'purple' : color}
                                                    style={{
                                                        margin: 0,
                                                        fontWeight: 'bold',
                                                        fontSize: 13,
                                                        padding: '1px 6px',
                                                        borderRadius: 4,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: 4
                                                    }}
                                                >
                                                    <span>{val.toFixed(2)}%</span>
                                                    {isIaSuspended && (
                                                        <Tooltip title="Suspès per ús d'IA (nota fixada a 0)">
                                                            <ThunderboltOutlined style={{ color: '#722ed1', fontSize: 13 }} />
                                                        </Tooltip>
                                                    )}
                                                </Tag>
                                            ) : (
                                                <Tag color="default" style={{ margin: 0, fontSize: 11, padding: '1px 6px' }}>N/P</Tag>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f0f0f0', paddingTop: 6 }}>
                                            <Typography.Text type="secondary" style={{ fontSize: 11, fontWeight: 500 }}>TESTS</Typography.Text>
                                            {record.hasTests ? (
                                                <Space size={6}>
                                                    <Tooltip title="Correctes"><Tag color="success" style={{ margin: 0, border: 'none', background: 'transparent', padding: 0, fontSize: 11 }}><FaCheck style={{ color: '#52c41a', marginRight: 3 }} />{record.correctes}</Tag></Tooltip>
                                                    <Tooltip title="Incorrectes"><Tag color="error" style={{ margin: 0, border: 'none', background: 'transparent', padding: 0, fontSize: 11 }}><FaTimes style={{ color: '#ff4d4f', marginRight: 3 }} />{record.incorrectes}</Tag></Tooltip>
                                                </Space>
                                            ) : (
                                                <Typography.Text type="secondary" style={{ fontSize: 11 }}>Sense tests</Typography.Text>
                                            )}
                                        </div>
                                    </div>

                                    <div style={{ flexGrow: 1 }}></div>

                                    {/* Actions */}
                                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
                                        <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        key: 'download_zip',
                                                        label: 'Baixar última entrega (ZIP)',
                                                        icon: <DownloadOutlined style={{ color: '#1890ff' }} />,
                                                        onClick: () => downloadUltimaEntrega(record)
                                                    },
                                                    {
                                                        key: 'eval_ide',
                                                        label: 'Evaluar des de l\'IDE',
                                                        icon: <PlayCircleOutlined style={{ color: '#059669' }} />,
                                                        onClick: () => evaluarUnoIde(record)
                                                    },
                                                    {
                                                        key: 'open_ide',
                                                        label: 'Obrir Modal IDE',
                                                        icon: <DesktopOutlined style={{ color: '#722ed1' }} />,
                                                        onClick: () => openIdeModal(record)
                                                    },
                                                    {
                                                        key: 'reeval_no_ide',
                                                        label: 'Re-evaluar (No IDE)',
                                                        icon: <BiRevision style={{ color: JutgeColors.colors.color2 }} />,
                                                        onClick: async () => {
                                                            const msgKey = `reeval-${record.id_usuari}`;
                                                            message.loading({ content: `Reevaluant ${record.alumne}...`, key: msgKey });
                                                            try {
                                                                let idEnviamentOrigin = null;
                                                                if (record.enviaments && record.enviaments.length > 0) {
                                                                    const sorted = [...record.enviaments].sort((a, b) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                                                                    idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                                                                }
                                                                if (!idEnviamentOrigin) {
                                                                    const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
                                                                    const token = localStorage.getItem('authToken');
                                                                    const envRes = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${record.id_usuari}/enviaments`, {
                                                                        headers: { 'Authorization': `Bearer ${token}` }
                                                                    });
                                                                    if (envRes.ok) {
                                                                        const envData = await envRes.json();
                                                                        if (envData && envData.length > 0) {
                                                                            const sorted = envData.sort((a: any, b: any) => new Date(b.moment || 0).getTime() - new Date(a.moment || 0).getTime());
                                                                            idEnviamentOrigin = sorted[0].id || sorted[0].id_enviament;
                                                                        }
                                                                    }
                                                                }

                                                                if (!idEnviamentOrigin) {
                                                                    message.error({ content: "No s'ha trobat l'enviament original", key: msgKey });
                                                                    return;
                                                                }

                                                                const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost') + ':8061';
                                                                const token = localStorage.getItem('authToken');
                                                                const response = await fetch(`${apiUrl}/jutge/practica/${id_practica}/usuaris/${record.id_usuari}/reenviar`, {
                                                                    method: 'POST',
                                                                    headers: {
                                                                        'Content-Type': 'application/json',
                                                                        'Authorization': `Bearer ${token}`
                                                                    },
                                                                    body: JSON.stringify({
                                                                        idEnviamentOrigin: idEnviamentOrigin,
                                                                        filename: "",
                                                                        content: "",
                                                                        files: [],
                                                                        deletedFiles: []
                                                                    })
                                                                });

                                                                if (response.ok) {
                                                                    message.success({ content: `Reevaluat OK`, key: msgKey });
                                                                    checkDades();
                                                                } else {
                                                                    message.error({ content: `Error al reevaluar`, key: msgKey });
                                                                }
                                                            } catch (e: any) {
                                                                message.error({ content: `Error: ${e.message}`, key: msgKey });
                                                            }
                                                        }
                                                    },
                                                    // Anàlisi IA d'aquest alumne: només en exàmens.
                                                    ...(isExamPractica ? [{
                                                        type: 'divider' as const
                                                    }, {
                                                        key: 'ia_alumne',
                                                        label: 'Analitzar amb IA',
                                                        icon: <ThunderboltOutlined style={{ color: '#722ed1' }} />,
                                                        onClick: () => analitzarAlumneIA(record)
                                                    }] : [])
                                                ]
                                            }}
                                            trigger={['click']}
                                        >
                                            <Button
                                                size="small"
                                                icon={<MoreOutlined />}
                                                loading={evalInProgress === record.id_usuari || analyzingIaUser === String(record.id_usuari)}
                                                style={{ fontSize: 11, padding: '0 6px', height: '24px' }}
                                            >
                                                Avaluar
                                            </Button>
                                        </Dropdown>

                                        <Tooltip title="Veure històric i codi">
                                            <Button
                                                type="primary"
                                                ghost
                                                size="small"
                                                icon={<FaCode />}
                                                onClick={() => openCodeModal(record)}
                                                style={{ fontSize: 11, padding: '0 6px', height: '24px' }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Pujar Fitxers Manualment">
                                            <Button
                                                type="dashed"
                                                size="small"
                                                icon={<UploadOutlined style={{ color: '#1890ff' }} />}
                                                onClick={() => setUploadModalStudent(record)}
                                                style={{ fontSize: 11, padding: '0 6px', height: '24px' }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Aplicar penalització (Resta)">
                                            <Button
                                                type="dashed"
                                                danger
                                                size="small"
                                                icon={<MdOutlineTextDecrease />}
                                                onClick={() => openPenaltyModal(record, 'subtract')}
                                                style={{ fontSize: 11, padding: '0 6px', height: '24px' }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Aplicar bonificació (Suma)">
                                            <Button
                                                type="dashed"
                                                style={{ borderColor: '#52c41a', color: '#52c41a', fontSize: 11, padding: '0 6px', height: '24px' }}
                                                size="small"
                                                icon={<MdOutlineTextDecrease style={{ transform: 'rotate(180deg)' }} />}
                                                onClick={() => openPenaltyModal(record, 'add')}
                                            >
                                                +
                                            </Button>
                                        </Tooltip>
                                    </div>

                                    {/* Subtle ID Tag in bottom right */}
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                        <Tag style={{
                                            margin: 0,
                                            fontSize: 9,
                                            lineHeight: '13px',
                                            padding: '0 3px',
                                            borderRadius: 3,
                                            color: '#bfbfbf',
                                            borderColor: '#f0f0f0',
                                            backgroundColor: '#fafafa'
                                        }}>
                                            #{record.id_usuari}
                                        </Tag>
                                    </div>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            )}

            <CodiFontModal
                open={isCodeModalOpen}
                onClose={() => setIsCodeModalOpen(false)}
                id_practica={id_practica + ""}
                record={selectedUserForPenalty}
                initialCode={selectedCode}
                files={selectedUserForPenalty?.files}
                applyHighlights={() => { }}
                onCodeSent={checkDades}
            />

            <PenaltyModal
                open={isPenaltyModalOpen}
                initialMode={initialMode}
                onClose={() => setIsPenaltyModalOpen(false)}
                onApply={(data) => {
                    PostJutgePracticaIdUsuariIdPenality(id_practica + "", selectedUserForPenalty?.id_usuari + "", {
                        penality: data.penalty,
                        text: data.reason,
                        tipus: data.tipus,
                        notaFixada: data.notaFixada,
                        esIa: data.esIa
                    }).then(() => {
                        message.success(data.esIa ? "Alumne suspès per ús d'IA" : "Puntuació actualitzada");
                        checkDades();
                    });
                }}
            />

            <Modal
                style={{ top: 20 }}
                open={isTestsModalOpen}
                onCancel={() => setIsTestsModalOpen(false)}
                footer={null}
                width={1200}
                title={`Historial d'enviaments - ${selectedUserForTests?.alumne || ""}`}
            >
                {selectedUserForTests && (
                    <PracticaIdTests
                        id_practica={Number(id_practica)}
                        id_usuari={Number(selectedUserForTests.id_usuari)}
                        id_aula={selectedUserForTests.idAula}
                    />
                )}
            </Modal>

            <Modal
                title={`Pujar Fitxers - ${uploadModalStudent?.alumne || ""}`}
                open={!!uploadModalStudent}
                onCancel={() => setUploadModalStudent(null)}
                footer={null}
                width={500}
                centered
            >
                {uploadModalStudent && (
                    <div style={{ padding: 12 }}>
                        <Typography.Paragraph type="secondary">
                            Puja els fitxers de codi (.java) per a l'alumne de forma manual.
                        </Typography.Paragraph>
                        <UploadCell record={uploadModalStudent} id_practica={id_practica + ""} />
                        <div style={{ marginTop: 24, textAlign: 'right' }}>
                            <Button onClick={() => setUploadModalStudent(null)}>Tancar</Button>
                        </div>
                    </div>
                )}
            </Modal>

            <Modal
                title="Evaluació Masiva IDE"
                open={isBulkEvalModalOpen}
                onCancel={() => !loading && setIsBulkEvalModalOpen(false)}
                footer={[
                    <Button key="close" onClick={() => setIsBulkEvalModalOpen(false)} disabled={loading}>
                        Tancar
                    </Button>
                ]}
                width={600}
            >
                <div style={{ marginBottom: 20 }}>
                    <Progress percent={evalProgress} status={loading ? "active" : "normal"} />
                </div>
                <div style={{ maxHeight: 400, overflowY: 'auto', background: '#fafafa', padding: 10, borderRadius: 8 }}>
                    <List
                        size="small"
                        dataSource={evalLogs}
                        renderItem={log => (
                            <List.Item>
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                    <Text strong>{log.name}</Text>
                                    <div>
                                        {log.status === 'loading' && <Tag icon={<LoadingOutlined spin />} color="processing">Evaluant...</Tag>}
                                        {log.status === 'success' && <Tag color="success">OK</Tag>}
                                        {log.status === 'warning' && <Tag color="warning">{log.msg || 'Avis'}</Tag>}
                                        {log.status === 'error' && <Tag color="error">{log.msg || 'Error'}</Tag>}
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
            </Modal>
            <Modal
                title={`💻 Entorn IDE - ${selectedUserForIde?.alumne || ""}`}
                open={isIdeModalOpen}
                onCancel={() => setIsIdeModalOpen(false)}
                footer={null}
                centered
                width={500}
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    {ideLoading ? (
                        <>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
                            <h3 style={{ marginTop: 20 }}>Preparant entorn...</h3>
                            <p>Connectant amb el contenidor de l'alumne.</p>
                        </>
                    ) : (
                        <>
                            <DesktopOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                            <h3>🚀 Entorno de {practica?.is_examen === 1 ? 'Examen' : 'Práctica'} Listo</h3>
                            {practica?.is_examen === 1 && (
                                <p>Importante: <b>No cierres y NO CAMBIES DE PESTAÑA</b>. Tu examen se bloqueará por seguridad si detectamos que estás usando otra pestaña.</p>
                            )}
                            <div style={{ wordBreak: 'break-all', fontSize: '11px', color: '#888', marginBottom: '10px' }}>
                                DEBUG URL: {ideUrl}
                            </div>
                            <div style={{ marginTop: 32 }}>
                                <Space size="large">
                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={<ExportOutlined />}
                                        onClick={() => {
                                            setIsIdeModalOpen(false);
                                            window.open(ideUrl, '_blank');
                                        }}
                                        style={{ background: '#722ed1', borderColor: '#722ed1', minWidth: 160 }}
                                    >
                                        Entrar al IDE
                                    </Button>
                                    <Button
                                        type="default"
                                        size="large"
                                        icon={<ExportOutlined />}
                                        onClick={loadFilesToNfs}
                                        style={{ minWidth: 160 }}
                                    >
                                        Carregar fitxers desde entrega
                                    </Button>
                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={<BiRefresh />}
                                        onClick={() => {
                                            setIsIdeModalOpen(false);
                                            if (selectedUserForIde) evaluarUnoIde(selectedUserForIde);
                                        }}
                                        style={{ background: '#5b21b6', borderColor: '#5b21b6', minWidth: 140 }}
                                    >
                                        Evaluar
                                    </Button>
                                </Space>
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {fileBrowserUser && (
                <IdeFileBrowserModal
                    visible={fileBrowserVisible}
                    onClose={() => setFileBrowserVisible(false)}
                    userId={fileBrowserUser.id}
                    studentName={fileBrowserUser.name}
                />
            )}

            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <GiftOutlined style={{ color: '#faad14', fontSize: 20 }} />
                        <span>Recompenses de {selectedStudentRewards?.student?.alumne || selectedStudentRewards?.student?.usuari}</span>
                    </div>
                }
                open={rewardsModalVisible}
                onCancel={() => {
                    setRewardsModalVisible(false);
                    setSelectedStudentRewards(null);
                }}
                footer={[
                    <Button key="close" type="primary" onClick={() => {
                        setRewardsModalVisible(false);
                        setSelectedStudentRewards(null);
                    }}>
                        Tancar
                    </Button>
                ]}
                width={650}
            >
                {(!selectedStudentRewards?.rewards || selectedStudentRewards.rewards.length === 0) ? (
                    <div style={{ textAlign: 'center', padding: '32px 0', color: '#888' }}>
                        <GiftOutlined style={{ fontSize: 36, color: '#d9d9d9', marginBottom: 12, display: 'block' }} />
                        <Typography.Text type="secondary">Aquesta pràctica no té recompenses configurades o assignades per a aquest alumne.</Typography.Text>
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
                        {selectedStudentRewards.rewards.map((rew: any, idx: number) => {
                            const isClaimed = Number(rew.reclamada) === 1 || Number(rew.obtained) === 1;
                            let items: any[] = [];

                            if (rew.id_javamon) {
                                const urlBase = process.env.REACT_APP_API_URL || 'http://localhost';
                                const imgUrl = `${urlBase}:8061/jutge/game/image/javamon/${rew.id_javamon}`;
                                const isEscapado = rew.estado_javamon === 'ESCAPADO';
                                items.push(
                                    <div key="javamon" style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f5f5f5', padding: '4px 10px', borderRadius: 8 }}>
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <img
                                                src={imgUrl}
                                                alt="javamon"
                                                style={{
                                                    width: 32,
                                                    height: 32,
                                                    objectFit: 'contain',
                                                    filter: isEscapado ? 'grayscale(100%) opacity(50%)' : 'none'
                                                }}
                                            />
                                            {isEscapado && (
                                                <span style={{ position: 'absolute', top: -5, right: -5, color: 'red', fontSize: '14px', fontWeight: 'bold' }}>✕</span>
                                            )}
                                        </div>
                                        <Typography.Text style={{ fontSize: 12 }}>
                                            {isEscapado ? 'Javamon (Escapat)' : 'Javamon (Capturat)'}
                                        </Typography.Text>
                                        {rew.javaball_lanzada ? (
                                            <Tag color={isEscapado ? 'volcano' : 'geekblue'} style={{ margin: 0, fontSize: 11 }}>
                                                🎯 {rew.javaball_lanzada}{rew.javaball_origen ? ` (${rew.javaball_origen === 'GAME' ? 'Joc' : 'Web'})` : ''}
                                            </Tag>
                                        ) : (
                                            isEscapado && (
                                                <Tag color="default" style={{ margin: 0, fontSize: 11 }}>
                                                    Sense Javaball
                                                </Tag>
                                            )
                                        )}
                                    </div>
                                );
                            }

                            if (rew.rewards_json) {
                                try {
                                    const parsed = typeof rew.rewards_json === 'string' ? JSON.parse(rew.rewards_json) : rew.rewards_json;
                                    if (Array.isArray(parsed)) {
                                        parsed.forEach((r: any, rIdx: number) => {
                                            if (r.tipo === 'PUNTUACION') {
                                                items.push(
                                                    <Tag key={`pts_${rIdx}`} color={isClaimed ? "gold" : "default"} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, opacity: isClaimed ? 1 : 0.85 }}>
                                                        +{r.valor} Punts
                                                    </Tag>
                                                );
                                            } else if (r.tipo !== 'JAVAMON_RANDOM' && r.tipo !== 'JAVAMON') {
                                                const urlBase = process.env.REACT_APP_API_URL || 'http://localhost';
                                                let typeSegment = (r.tipo || '').toLowerCase();
                                                if (typeSegment === "escudo") typeSegment = "escut";
                                                if (typeSegment === "arco") typeSegment = "arc";
                                                if (typeSegment === "shop_item") typeSegment = "shop";
                                                const imgUrl = `${urlBase}:8061/jutge/game/image/${typeSegment}/${r.id_item}`;
                                                items.push(
                                                    <div key={`item_${rIdx}`} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 6,
                                                        background: isClaimed ? '#f9f9f9' : '#fafafa',
                                                        border: isClaimed ? '1px solid #eee' : '1px dashed #d9d9d9',
                                                        padding: '3px 8px',
                                                        borderRadius: 6,
                                                        opacity: isClaimed ? 1 : 0.85
                                                    }}>
                                                        <img src={imgUrl} alt={r.tipo} style={{ width: 22, height: 22, objectFit: 'contain' }} />
                                                        <Typography.Text style={{ fontSize: 11 }}>{r.tipo}</Typography.Text>
                                                    </div>
                                                );
                                            } else if (!isClaimed && (r.tipo === 'JAVAMON_RANDOM' || r.tipo === 'JAVAMON')) {
                                                items.push(
                                                    <Tag key={`jm_${rIdx}`} color="purple" style={{ fontSize: 12, padding: '4px 8px', borderRadius: 6, opacity: 0.85 }}>
                                                        Javamon pendent
                                                    </Tag>
                                                );
                                            }
                                        });
                                    }
                                } catch (e) { /* ignore json parse */ }
                            }

                            return (
                                <Card
                                    key={idx}
                                    size="small"
                                    style={{
                                        borderRadius: 8,
                                        borderColor: isClaimed ? '#b7eb8f' : '#f0f0f0',
                                        backgroundColor: isClaimed ? '#fcffe6' : '#fafafa',
                                        borderStyle: isClaimed ? 'solid' : 'dashed'
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                        <Typography.Text strong style={{ fontSize: 13, color: isClaimed ? '#52c41a' : '#8c8c8c' }}>
                                            {rew.nom_problema || practica?.nom || `Exercici #${rew.id_problema}`}
                                        </Typography.Text>
                                        {isClaimed ? (
                                            <Tag color="success">Reclamada</Tag>
                                        ) : (
                                            <Tag color="warning">Pendent / No reclamada</Tag>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginTop: 4 }}>
                                        {items.length > 0 ? items : <Typography.Text type="secondary" style={{ fontSize: 11 }}>Sense ítems addicionals</Typography.Text>}
                                    </div>
                                </Card>
                            );
                        })}
                    </div>
                )}
            </Modal>
            {/* Modal d'Historial de Telemetria (Monitoreo IDE per Alumne) */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <HistoryOutlined style={{ color: '#1890ff', fontSize: 20 }} />
                        <span>
                            Historial IDE: {telemetryStudent?.nom ? `${telemetryStudent.nom} ${telemetryStudent.cognoms || ''}` : telemetryStudent?.usuari}
                        </span>
                    </div>
                }
                open={telemetryModalVisible}
                onCancel={() => {
                    setTelemetryModalVisible(false);
                    setTelemetryStudent(null);
                }}
                footer={[
                    <Button key="close" type="primary" onClick={() => {
                        setTelemetryModalVisible(false);
                        setTelemetryStudent(null);
                    }}>
                        Tancar
                    </Button>
                ]}
                width={780}
            >
                {telemetryStudent && (
                    <>
                        {/* Capçalera destacada amb el nom i dades de l'alumne */}
                        {(() => {
                            const studentFullName = telemetryStudent?.nom
                                ? `${telemetryStudent.nom} ${telemetryStudent.cognoms || ''}`.trim()
                                : (telemetryStudent?.alumne || telemetryStudent?.usuari || `Usuari #${telemetryStudent?.id_usuari}`);
                            const initials = (studentFullName || 'AL').substring(0, 2).toUpperCase();
                            const avatarSrc = getAvatarSrc(avatars[String(telemetryStudent.id_usuari)] || telemetryStudent.avatar);
                            const tel = getStudentTelemetryStatus(telemetryStudent);
                            const isSusp = !!iaSuspendedUsers[String(telemetryStudent.id_usuari)];

                            return (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 14,
                                    padding: '12px 16px',
                                    borderRadius: 10,
                                    background: 'linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%)',
                                    border: '1px solid #adc6ff',
                                    boxShadow: '0 2px 6px rgba(24, 144, 255, 0.08)'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                        <Avatar
                                            size={44}
                                            src={avatarSrc}
                                            style={{
                                                backgroundColor: avatarSrc ? undefined : '#1890ff',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                fontSize: 16,
                                                border: '2px solid #fff',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            {initials}
                                        </Avatar>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <Typography.Text strong style={{ fontSize: 16, color: '#1d39c4' }}>
                                                    {studentFullName}
                                                </Typography.Text>
                                                {isSusp && (
                                                    <Tag color="purple" icon={<ThunderboltOutlined />} style={{ margin: 0, fontWeight: 'bold' }}>
                                                        IA Suspès
                                                    </Tag>
                                                )}
                                                {isLocked(telemetryStudent) && (
                                                    <Tag color="red" icon={<LockOutlined />} style={{ margin: 0 }}>
                                                        Bloquejat
                                                    </Tag>
                                                )}
                                            </div>
                                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 2 }}>
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    ID: <strong>{telemetryStudent.id_usuari}</strong>
                                                </Typography.Text>
                                                {telemetryStudent.nomaula && (
                                                    <Tag style={{ fontSize: 11, margin: 0 }}>{telemetryStudent.nomaula}</Tag>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <Space size="small">
                                        {tel.status === 'activo' && <Tag color="green" icon={<ThunderboltOutlined />} style={{ padding: '2px 8px', fontWeight: 'bold' }}>ACTIU (Escribint)</Tag>}
                                        {tel.status === 'conectado' && <Tag color="blue" icon={<DesktopOutlined />} style={{ padding: '2px 8px' }}>CONNECTAT (IDE Obert)</Tag>}
                                        {tel.status === 'desconectado' && <Tag color="default" style={{ padding: '2px 8px' }}>DESCONNECTAT</Tag>}
                                    </Space>
                                </div>
                            );
                        })()}

                        {/* Selector de dia y estadísticas del día */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8, background: '#fafafa', padding: '10px 14px', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                            <Space size="small" wrap>
                                <Tooltip title="Mostra només l'activitat d'aquesta pràctica/examen (ignora el filtre per dia). Ideal quan l'examen va ser un sol dia.">
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: 8 }}>
                                        <Switch
                                            size="small"
                                            checked={filterByExercise}
                                            onChange={setFilterByExercise}
                                        />
                                        <span style={{ fontSize: 13, fontWeight: 500 }}>Només aquest exercici</span>
                                    </span>
                                </Tooltip>
                                <Button
                                    icon={<LeftOutlined />}
                                    disabled={filterByExercise}
                                    onClick={() => setTelemetryDate(d => d.subtract(1, 'day'))}
                                    title="Dia anterior"
                                />
                                <DatePicker
                                    value={telemetryDate}
                                    onChange={d => d && setTelemetryDate(d)}
                                    allowClear={false}
                                    disabled={filterByExercise}
                                    format="DD/MM/YYYY"
                                    style={{ width: 130 }}
                                />
                                <Button
                                    icon={<RightOutlined />}
                                    disabled={filterByExercise || telemetryDate.isSame(dayjs(), 'day')}
                                    onClick={() => setTelemetryDate(d => d.add(1, 'day'))}
                                    title="Dia següent"
                                />
                                {!filterByExercise && !isTodaySelected && (
                                    <Button
                                        type="dashed"
                                        size="small"
                                        onClick={() => setTelemetryDate(dayjs())}
                                    >
                                        Avui
                                    </Button>
                                )}
                            </Space>

                            {/* Resumen del estado actual del alumno */}
                            <Space size="small">
                                {(() => {
                                    const tel = getStudentTelemetryStatus(telemetryStudent);
                                    if (tel.status === 'activo') return <Tag color="green" icon={<ThunderboltOutlined />}>ACTIU (Escribint codi)</Tag>;
                                    if (tel.status === 'conectado') return <Tag color="blue" icon={<DesktopOutlined />}>CONNECTAT (IDE Obert)</Tag>;
                                    return <Tag color="default">DESCONNECTAT</Tag>;
                                })()}
                            </Space>
                        </div>

                        <Tabs
                            activeKey={activeTelemetryTabKey}
                            onChange={(key: any) => setActiveTelemetryTabKey(key)}
                            items={[
                                {
                                    key: 'timeline',
                                    label: (
                                        <Space>
                                            <ClockCircleOutlined />
                                            <span>Línia de Temps</span>
                                            <Tag style={{ marginLeft: 4 }}>{displayedTelemetryEvents.length}</Tag>
                                        </Space>
                                    ),
                                    children: (
                                        <div>
                                            {/* Filtre per fitxer treballat */}
                                            {Object.keys(availableTelemetryFiles).length > 0 && (
                                                <div style={{ marginBottom: 16, padding: '8px 12px', background: '#ffffff', borderRadius: 6, border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                                                    <Space size="small">
                                                        <Text strong style={{ fontSize: 13 }}><FileOutlined /> Fitxer:</Text>
                                                        <Select
                                                            style={{ width: 300 }}
                                                            allowClear
                                                            placeholder="Tots els fitxers"
                                                            value={selectedFileFilter}
                                                            onChange={val => setSelectedFileFilter(val || null)}
                                                        >
                                                            {Object.entries(availableTelemetryFiles).map(([fname, info]) => (
                                                                <Select.Option key={fname} value={fname}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <span>{fname}</span>
                                                                        <Space size={4}>
                                                                            {info.edits > 0 && <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>{info.edits} edits</Tag>}
                                                                            <Tag style={{ fontSize: 10, margin: 0 }}>{info.count} regs</Tag>
                                                                        </Space>
                                                                    </div>
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Space>
                                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                                        {Object.keys(availableTelemetryFiles).length} {Object.keys(availableTelemetryFiles).length === 1 ? 'fitxer detectat' : 'fitxers detectats'}
                                                    </Text>
                                                </div>
                                            )}

                                            {/* Línia temporal d'esdeveniments */}
                                            {telemetryLoading ? (
                                                <div style={{ textAlign: 'center', padding: 32 }}>Carregant historial de telemetria...</div>
                                            ) : groupedTelemetryItems.length === 0 ? (
                                                <Empty description={filterByExercise ? "Sense activitat registrada per a aquest exercici" : `Sense activitat registrada per al ${telemetryDate.format('DD/MM/YYYY')}`} style={{ padding: '24px 0' }} />
                                            ) : (
                                                <Timeline
                                                    style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}
                                                    items={groupedTelemetryItems.map((item: any, idx: number) => {
                                                        const ev = item.representativeEvent;
                                                        const st = item.eventStatus;

                                                        const statusColor = st === 'activo' ? 'green' : st === 'conectado' ? 'blue' : 'gray';
                                                        const statusDot = st === 'activo'
                                                            ? <ThunderboltOutlined style={{ color: '#52c41a' }} />
                                                            : st === 'conectado'
                                                                ? <DesktopOutlined style={{ color: '#1890ff' }} />
                                                                : <MinusCircleTwoTone twoToneColor="#bbb" />;
                                                        const statusTag = st === 'activo'
                                                            ? <Tag color="green" icon={<ThunderboltOutlined />}>actiu</Tag>
                                                            : st === 'conectado'
                                                                ? <Tag color="blue" icon={<DesktopOutlined />}>connectat</Tag>
                                                                : <Tag>desconnectat</Tag>;

                                                        if (item.isGroup || (item.files && item.files.length > 1)) {
                                                            const groupLabel = st === 'activo'
                                                                ? 'actiu sense edicions' : st === 'conectado'
                                                                    ? 'connectat sense canvis' : 'desconnectat';
                                                            return {
                                                                key: `group-${idx}-${item.startTs}`,
                                                                color: statusColor,
                                                                dot: statusDot,
                                                                children: (
                                                                    <div style={{ padding: '4px 0' }}>
                                                                        <Space wrap>
                                                                            <Text strong>
                                                                                {formatDateTime(item.startTs)} — {formatDateTime(item.endTs)}
                                                                            </Text>
                                                                            <Tag color={statusColor}>
                                                                                {item.count} intervals {groupLabel}
                                                                            </Tag>
                                                                            {item.totalActiveSeconds > 0 && (
                                                                                <Tag>{formatDuration(item.totalActiveSeconds)} acumulats</Tag>
                                                                            )}
                                                                        </Space>
                                                                        {item.files && item.files.length > 0 && (
                                                                            <div style={{ fontSize: 12, color: '#888', marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                                <FileOutlined style={{ marginRight: 4 }} />
                                                                                {item.files.map((f: string) => (
                                                                                    <Tag key={f} style={{ fontSize: 11, margin: 0 }}>{f}</Tag>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )
                                                            };
                                                        }

                                                        return {
                                                            key: `ev-${item.representativeEvent?.id || idx}`,
                                                            color: statusColor,
                                                            dot: statusDot,
                                                            children: (
                                                                <div>
                                                                    <div>
                                                                        <Text strong>{formatDateTime(ev.event_ts)}</Text>{' '}
                                                                        {statusTag}
                                                                        {ev.edits > 0 && <Tag color="purple">{ev.edits} edicions</Tag>}
                                                                        {(ev.runs || 0) > 0 && <Tag color="cyan" icon={<PlayCircleOutlined />}>{ev.runs} run</Tag>}
                                                                        {(ev.debugs || 0) > 0 && <Tag color="magenta" icon={<BugOutlined />}>{ev.debugs} debug</Tag>}
                                                                        {ev.active_seconds > 0 && <Tag>{formatDuration(ev.active_seconds)}</Tag>}
                                                                    </div>
                                                                    <div style={{ fontSize: 12, color: '#666', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div>
                                                                            <FileOutlined /> {ev.file || '—'}
                                                                            {ev.language ? <Tag color="blue" style={{ marginLeft: 8 }}>{ev.language}</Tag> : null}
                                                                            {ev.project ? <Tag style={{ marginLeft: 4 }}>{ev.project}</Tag> : null}
                                                                        </div>
                                                                        {ev.code_snippet && item.hasCodeChange && (
                                                                            <Space>
                                                                                <Button
                                                                                    size="small"
                                                                                    type="primary"
                                                                                    ghost
                                                                                    icon={<CodeOutlined />}
                                                                                    onClick={() => {
                                                                                        const diffIdx = diffItems.indexOf(item);
                                                                                        if (diffIdx !== -1) {
                                                                                            openDiffModalAtIndex(diffIdx);
                                                                                        } else {
                                                                                            setPreviousCodeSnippet(item.prevSnippet);
                                                                                            setCodeViewMode(item.prevSnippet ? 'diff' : 'current');
                                                                                            setSelectedCodeEvent(ev);
                                                                                            setCodeModalVisible(true);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    Veure diff / codi
                                                                                </Button>
                                                                            </Space>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                        };
                                                    })}
                                                />
                                            )}
                                        </div>
                                    )
                                },
                                {
                                    key: 'clipboard',
                                    label: (
                                        <Space>
                                            <CopyOutlined />
                                            <span>Copiar / Pegar</span>
                                            <Tag color={displayedClipboardEvents.length > 0 ? 'red' : 'default'} style={{ marginLeft: 4 }}>
                                                {displayedClipboardEvents.length}
                                            </Tag>
                                        </Space>
                                    ),
                                    children: (
                                        <div>
                                            {/* Filtre per Acció de copiar/pegar */}
                                            {displayedClipboardEvents.length > 0 && (
                                                <div style={{ marginBottom: 14, padding: '8px 12px', background: '#ffffff', borderRadius: 6, border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                                                    <Space size="small">
                                                        <Text strong style={{ fontSize: 13 }}><CopyOutlined /> Filtrar per Acció:</Text>
                                                        <Radio.Group
                                                            size="small"
                                                            value={clipboardActionFilter || 'ALL'}
                                                            onChange={e => setClipboardActionFilter(e.target.value === 'ALL' ? null : e.target.value)}
                                                            buttonStyle="solid"
                                                        >
                                                            <Radio.Button value="ALL">Totes ({displayedClipboardEvents.length})</Radio.Button>
                                                            <Radio.Button value="PASTE">
                                                                PASTE ({displayedClipboardEvents.filter(e => String(e.action_type || '').toUpperCase() === 'PASTE').length})
                                                            </Radio.Button>
                                                            <Radio.Button value="COPY">
                                                                COPY ({displayedClipboardEvents.filter(e => String(e.action_type || '').toUpperCase() === 'COPY').length})
                                                            </Radio.Button>
                                                            <Radio.Button value="CUT">
                                                                CUT ({displayedClipboardEvents.filter(e => String(e.action_type || '').toUpperCase() === 'CUT').length})
                                                            </Radio.Button>
                                                            {displayedClipboardEvents.some(e => String(e.action_type || '').toUpperCase() === 'FILE_DROP') && (
                                                                <Radio.Button value="FILE_DROP">
                                                                    FILE DROP ({displayedClipboardEvents.filter(e => String(e.action_type || '').toUpperCase() === 'FILE_DROP').length})
                                                                </Radio.Button>
                                                            )}
                                                        </Radio.Group>
                                                    </Space>
                                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                                        {displayedClipboardEvents.filter(ev => !clipboardActionFilter || String(ev.action_type || '').toUpperCase() === clipboardActionFilter).length} de {displayedClipboardEvents.length} accions
                                                    </Text>
                                                </div>
                                            )}

                                            {telemetryLoading ? (
                                                <div style={{ textAlign: 'center', padding: 32 }}>Carregant esdeveniments de portapapers...</div>
                                            ) : displayedClipboardEvents.length === 0 ? (
                                                <Empty description={filterByExercise ? "No s'han registrat accions de copiar o pegar en aquest exercici" : `No s'han registrat accions de copiar o pegar el ${telemetryDate.format('DD/MM/YYYY')}`} style={{ padding: '24px 0' }} />
                                            ) : (
                                                <Table
                                                    dataSource={displayedClipboardEvents.filter(ev => !clipboardActionFilter || String(ev.action_type || '').toUpperCase() === clipboardActionFilter)}
                                                    rowKey="id"
                                                    size="small"
                                                    pagination={{ pageSize: 8 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 120,
                                                            filters: [
                                                                { text: 'PASTE', value: 'PASTE' },
                                                                { text: 'COPY', value: 'COPY' },
                                                                { text: 'CUT', value: 'CUT' },
                                                                { text: 'FILE_DROP', value: 'FILE_DROP' }
                                                            ],
                                                            onFilter: (value: any, record: any) => String(record.action_type || '').toUpperCase() === String(value).toUpperCase(),
                                                            render: (action: string) => {
                                                                const act = (action || '').toUpperCase();
                                                                if (act === 'FILE_DROP') {
                                                                    return <Tag color="magenta" style={{ fontWeight: 'bold' }}>FILE DROP</Tag>;
                                                                }
                                                                const color = act === 'PASTE' ? 'orange' : act === 'COPY' ? 'blue' : act === 'CUT' ? 'volcano' : 'green';
                                                                return <Tag color={color} style={{ fontWeight: 'bold' }}>{act}</Tag>;
                                                            }
                                                        },
                                                        {
                                                            title: 'Origen',
                                                            dataIndex: 'source_element',
                                                            key: 'source_element',
                                                            width: 120,
                                                            render: (src: string) => <Tag color="geekblue">{src || 'EXAM_FRAME'}</Tag>
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 150,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Contingut Copiat/Pegat',
                                                            dataIndex: 'content_text',
                                                            key: 'content_text',
                                                            render: (txt: string) => (
                                                                <div style={{
                                                                    maxHeight: 70,
                                                                    maxWidth: 320,
                                                                    overflowY: 'auto',
                                                                    background: '#f5f5f5',
                                                                    padding: '4px 6px',
                                                                    borderRadius: 4,
                                                                    fontFamily: 'monospace',
                                                                    fontSize: 11,
                                                                    whiteSpace: 'pre-wrap',
                                                                    wordBreak: 'break-all'
                                                                }}>
                                                                    {txt || '(buit)'}
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                },
                                {
                                    key: 'locks',
                                    label: (
                                        <Space>
                                            <LockOutlined />
                                            <span>Bloquejos IDE</span>
                                            <Tag color={displayedLockEvents.length > 0 ? 'volcano' : 'default'} style={{ marginLeft: 4 }}>
                                                {displayedLockEvents.length}
                                            </Tag>
                                        </Space>
                                    ),
                                    children: (
                                        <div>
                                            {telemetryLoading ? (
                                                <div style={{ textAlign: 'center', padding: 32 }}>Carregant historial de bloquejos...</div>
                                            ) : displayedLockEvents.length === 0 ? (
                                                <Empty description={filterByExercise ? "No s'han registrat bloquejos/desbloquejos en aquest exercici" : `No s'han registrat bloquejos/desbloquejos el ${telemetryDate.format('DD/MM/YYYY')}`} style={{ padding: '24px 0' }} />
                                            ) : (
                                                <Table
                                                    dataSource={displayedLockEvents}
                                                    rowKey="id"
                                                    size="small"
                                                    pagination={{ pageSize: 10 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 110,
                                                            render: (a: string) => a === 'LOCK'
                                                                ? <Tag color="red" icon={<LockOutlined />} style={{ fontWeight: 'bold' }}>BLOQUEIG</Tag>
                                                                : <Tag color="green" style={{ fontWeight: 'bold' }}>DESBLOQUEIG</Tag>
                                                        },
                                                        {
                                                            title: 'Motiu',
                                                            dataIndex: 'reason',
                                                            key: 'reason',
                                                            width: 140,
                                                            render: (r: string) => {
                                                                if (!r) return '—';
                                                                const label = r === 'FOCUS_LOST' ? 'Pèrdua de focus'
                                                                    : r === 'MANUAL' ? 'Manual'
                                                                    : r;
                                                                return <Tag color={r === 'FOCUS_LOST' ? 'orange' : 'default'}>{label}</Tag>;
                                                            }
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 160,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Desbloquejat per',
                                                            dataIndex: 'actor_nom',
                                                            key: 'actor_nom',
                                                            width: 160,
                                                            render: (nom: string, row: any) => row.action_type === 'UNLOCK'
                                                                ? (nom || (row.actor_id ? `#${row.actor_id}` : '—'))
                                                                : '—'
                                                        },
                                                        {
                                                            title: 'Detall',
                                                            dataIndex: 'detail',
                                                            key: 'detail',
                                                            render: (d: string) => d
                                                                ? <div style={{ maxWidth: 280, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12 }}>{d}</div>
                                                                : '—'
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </>
                )}
            </Modal>

            {/* Modal detall Anàlisi IA (sospita d'ús d'IA generativa) */}
            <Modal
                title={
                    <Space>
                        <WarningOutlined style={{ color: '#722ed1' }} />
                        <span>Anàlisi IA — {iaDetailStudent?.student?.alumne || ''}</span>
                        {iaDetailStudent?.susp?.suspicion_level && (
                            <Tag color={iaDetailStudent.susp.suspicion_level === 'ALTA' ? 'red' : iaDetailStudent.susp.suspicion_level === 'MITJA' ? 'orange' : iaDetailStudent.susp.suspicion_level === 'BAIXA' ? 'green' : 'default'} style={{ fontWeight: 'bold' }}>
                                Sospita: {iaDetailStudent.susp.suspicion_level} ({iaDetailStudent.susp.score ?? 0}/100)
                            </Tag>
                        )}
                    </Space>
                }
                open={iaDetailVisible}
                onCancel={() => { setIaDetailVisible(false); setIaDetailStudent(null); }}
                footer={[
                    <Button
                        key="suspendre"
                        danger
                        type="primary"
                        icon={<WarningOutlined />}
                        loading={suspendingIa}
                        onClick={() => confirmSuspendrePerIA(iaDetailStudent?.student)}
                    >
                        Suspendre per ús d'IA generativa
                    </Button>,
                    <Button key="tancar" onClick={() => { setIaDetailVisible(false); setIaDetailStudent(null); }}>Tancar</Button>
                ]}
                width={820}
            >
                {(() => {
                    const susp = iaDetailStudent?.susp;
                    if (!susp) return <Empty description="Sense anàlisi per aquest alumne. Executa 'Analitzar amb IA'." />;
                    let timeline: any[] = [];
                    try {
                        if (Array.isArray(susp.timeline)) {
                            timeline = susp.timeline;
                        } else if (typeof susp.evidence_json === 'string') {
                            timeline = susp.evidence_json ? JSON.parse(susp.evidence_json) : [];
                        } else if (Array.isArray(susp.evidence_json)) {
                            timeline = susp.evidence_json;
                        }
                    } catch (e) { timeline = []; }
                    return (
                        <div>
                            <Card size="small" style={{ marginBottom: 16, background: '#faf5ff', borderColor: '#d3adf7' }}>
                                <Typography.Text strong>Veredicte:</Typography.Text>
                                <Typography.Paragraph style={{ marginBottom: 0, marginTop: 4, whiteSpace: 'pre-wrap' }}>
                                    {susp.summary || '(sense resum)'}
                                </Typography.Paragraph>
                                {susp.analyzed_at && (
                                    <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                        Analitzat: {formatDateTime(susp.analyzed_at)}
                                    </Typography.Text>
                                )}
                            </Card>

                            <Typography.Title level={5} style={{ marginBottom: 12 }}>
                                <ClockCircleOutlined /> Timeline d'evidències
                            </Typography.Title>
                            {timeline.length === 0 ? (
                                <Empty description="Sense evidències registrades" />
                            ) : (
                                <Timeline
                                    items={timeline.map((ev: any) => {
                                        const tipus = ev.tipus || ev.type || 'OTHER';
                                        const color = tipus === 'PASTE' ? 'orange' : tipus === 'FOCUS_LOST' ? 'red' : tipus === 'CODE_JUMP' ? 'purple' : 'blue';
                                        return {
                                            color,
                                            children: (
                                                <div>
                                                    <Space>
                                                        <Tag color={color}>{tipus}</Tag>
                                                        <Typography.Text type="secondary" style={{ fontSize: 12 }}>{ev.ts || ev.event_ts || ''}</Typography.Text>
                                                    </Space>
                                                    <div style={{ marginTop: 4 }}>{ev.detall || ev.detail || ''}</div>
                                                    {(() => {
                                                        // Enllacem amb el portapapers REAL (PASTE o COPY) per mostrar-ne el contingut sencer.
                                                        const clip = (tipus === 'PASTE' || tipus === 'COPY') ? findClipboardForEvidence(ev) : null;
                                                        const fullText = clip ? String(clip.content_text ?? '') : '';
                                                        const resum = ev.evidencia || ev.evidence || '';
                                                        const etiqueta = tipus === 'COPY' ? 'Contingut real copiat' : 'Contingut real enganxat';
                                                        // Si tenim el contingut real, el mostrem sencer (amb scroll) + botó per obrir-lo gran.
                                                        if (clip && fullText) {
                                                            const len = Number(clip.content_length ?? fullText.length);
                                                            return (
                                                                <div style={{ marginTop: 6 }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                                                                        <Tag color="geekblue" style={{ margin: 0, fontSize: 10 }}>{etiqueta}</Tag>
                                                                        {clip.source_element && (
                                                                            <Tag color="default" style={{ margin: 0, fontSize: 10 }}>origen: {clip.source_element}</Tag>
                                                                        )}
                                                                        <Typography.Text type="secondary" style={{ fontSize: 11 }}>{len} caràcters</Typography.Text>
                                                                        <Button
                                                                            size="small"
                                                                            type="link"
                                                                            style={{ padding: 0, height: 'auto', fontSize: 11 }}
                                                                            onClick={() => openPasteFull(fullText, clip.event_ts)}
                                                                        >
                                                                            Veure complet
                                                                        </Button>
                                                                    </div>
                                                                    <pre style={{
                                                                        margin: 0, background: '#1e1e1e', color: '#d4d4d4',
                                                                        padding: '8px 10px', borderRadius: 4, fontSize: 11,
                                                                        maxHeight: 320, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word'
                                                                    }}>{fullText}</pre>
                                                                </div>
                                                            );
                                                        }
                                                        // Fallback: resum del model (pot dur "...").
                                                        if (resum) {
                                                            return (
                                                                <pre style={{
                                                                    marginTop: 6, background: '#1e1e1e', color: '#d4d4d4',
                                                                    padding: '8px 10px', borderRadius: 4, fontSize: 11,
                                                                    maxHeight: 180, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word'
                                                                }}>{resum}</pre>
                                                            );
                                                        }
                                                        return null;
                                                    })()}
                                                </div>
                                            )
                                        };
                                    })}
                                />
                            )}
                        </div>
                    );
                })()}
            </Modal>

            {/* Modal Visor de Codi amb vista Diff o Completa */}
            <Modal
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 32, flexWrap: 'wrap', gap: 8 }}>
                        <Space wrap>
                            <CodeOutlined />
                            <span>
                                <strong>{selectedCodeEvent?.file || 'fitxer'}</strong> — {formatDateTime(selectedCodeEvent?.event_ts)}
                            </span>
                            {selectedCodeEvent?.language && <Tag color="blue">{selectedCodeEvent.language}</Tag>}
                            {selectedCodeEvent?.edits ? <Tag color="purple">{selectedCodeEvent.edits} edicions</Tag> : null}
                            {diffItems.length > 1 && (
                                <Tag color="geekblue" style={{ fontWeight: 'bold' }}>
                                    {currentDiffIndex + 1} de {diffItems.length}
                                </Tag>
                            )}
                        </Space>
                        <Space size="middle">
                            {diffItems.length > 1 && (
                                <Space.Compact size="small">
                                    <Button
                                        icon={<LeftOutlined />}
                                        disabled={currentDiffIndex <= 0}
                                        onClick={() => openDiffModalAtIndex(currentDiffIndex - 1)}
                                        title="Canvi anterior (més recent)"
                                    >
                                        Anterior
                                    </Button>
                                    <Button
                                        icon={<RightOutlined />}
                                        disabled={currentDiffIndex >= diffItems.length - 1}
                                        onClick={() => openDiffModalAtIndex(currentDiffIndex + 1)}
                                        title="Canvi següent (més antic)"
                                    >
                                        Següent
                                    </Button>
                                </Space.Compact>
                            )}
                            {previousCodeSnippet && (
                                <Radio.Group
                                    size="small"
                                    value={codeViewMode}
                                    onChange={(e: any) => setCodeViewMode(e.target.value)}
                                    buttonStyle="solid"
                                >
                                    <Radio.Button value="diff">Veure Canvis (Diff)</Radio.Button>
                                    <Radio.Button value="current">Codi Complet</Radio.Button>
                                </Radio.Group>
                            )}
                        </Space>
                    </div>
                }
                open={codeModalVisible}
                onCancel={() => setCodeModalVisible(false)}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            {diffItems.length > 1 && (
                                <Space>
                                    <Button
                                        icon={<LeftOutlined />}
                                        disabled={currentDiffIndex <= 0}
                                        onClick={() => openDiffModalAtIndex(currentDiffIndex - 1)}
                                    >
                                        Anterior
                                    </Button>
                                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                        {currentDiffIndex + 1} / {diffItems.length}
                                    </Typography.Text>
                                    <Button
                                        icon={<RightOutlined />}
                                        disabled={currentDiffIndex >= diffItems.length - 1}
                                        onClick={() => openDiffModalAtIndex(currentDiffIndex + 1)}
                                    >
                                        Següent
                                    </Button>
                                </Space>
                            )}
                        </div>
                        <Button type="primary" onClick={() => setCodeModalVisible(false)}>Tancar</Button>
                    </div>
                }
                width={940}
                bodyStyle={{ padding: 0 }}
            >
                <div style={{ height: 480, borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0' }}>
                    {codeViewMode === 'diff' && previousCodeSnippet ? (
                        <DiffEditor
                            height="100%"
                            language={(selectedCodeEvent?.language || 'java').toLowerCase()}
                            original={previousCodeSnippet}
                            modified={selectedCodeEvent?.code_snippet || ''}
                            theme="vs-dark"
                            options={{
                                readOnly: true,
                                renderSideBySide: true,
                                minimap: { enabled: false },
                                fontSize: 13,
                                lineNumbers: 'on',
                                scrollBeyondLastLine: false,
                                automaticLayout: true
                            }}
                        />
                    ) : (
                        <Editor
                            height="100%"
                            language={(selectedCodeEvent?.language || 'java').toLowerCase()}
                            value={selectedCodeEvent?.code_snippet || '// No hi ha contingut disponible'}
                            theme="vs-dark"
                            options={{
                                readOnly: true,
                                minimap: { enabled: false },
                                fontSize: 13,
                                lineNumbers: 'on',
                                scrollBeyondLastLine: false,
                                automaticLayout: true
                            }}
                        />
                    )}
                </div>
            </Modal>

            {/* Modal: contingut sencer d'un pegat concret */}
            <Modal
                title={
                    <Space>
                        <CopyOutlined style={{ color: '#722ed1' }} />
                        <span>Contingut complet del pegat</span>
                        {pasteFullContent?.length != null && (
                            <Tag color="geekblue">{pasteFullContent.length} caràcters</Tag>
                        )}
                        {pasteFullContent?.ts && (
                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                {formatDateTime(pasteFullContent.ts)}
                            </Typography.Text>
                        )}
                    </Space>
                }
                open={pasteFullVisible}
                onCancel={() => setPasteFullVisible(false)}
                footer={[
                    <Button key="copy" icon={<CopyOutlined />} onClick={() => {
                        try { navigator.clipboard.writeText(pasteFullContent?.text || ''); message.success('Copiat al porta-retalls'); } catch (e) { }
                    }}>Copiar</Button>,
                    <Button key="close" onClick={() => setPasteFullVisible(false)}>Tancar</Button>
                ]}
                width={860}
                bodyStyle={{ padding: 0 }}
            >
                <pre style={{
                    margin: 0, background: '#1e1e1e', color: '#d4d4d4',
                    padding: '12px 14px', fontSize: 12, lineHeight: 1.5,
                    maxHeight: 520, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word'
                }}>{pasteFullContent?.text || '(buit)'}</pre>
            </Modal>

            {/* Modal de progrés orientatiu de l'anàlisi massiva amb IA */}
            <Modal
                open={iaProgressVisible}
                closable={false}
                maskClosable={false}
                keyboard={false}
                footer={null}
                width={440}
                centered
                title={
                    <Space>
                        <ThunderboltOutlined style={{ color: '#722ed1' }} />
                        <span>Analitzant entregues amb IA</span>
                    </Space>
                }
            >
                <div style={{ textAlign: 'center', padding: '12px 4px' }}>
                    <Progress
                        type="line"
                        percent={Math.round(iaProgressPercent)}
                        status={iaProgressPercent >= 100 ? 'success' : 'active'}
                        strokeColor={{ from: '#722ed1', to: '#b37feb' }}
                    />
                    <div style={{ marginTop: 12 }}>
                        <Text type="secondary">
                            {iaProgressPercent >= 100
                                ? 'Anàlisi completada'
                                : `Analitzant ${iaProgressTotal > 0 ? `${iaProgressTotal} alumne(s)` : 'les entregues'}… pot trigar una estona`}
                        </Text>
                    </div>
                    <div style={{ marginTop: 4 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            Es correlacionen copiar/pegar, salts de codi, pèrdues de focus i el codi entregat.
                        </Text>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default PracticaIdAlumnes;
